import type { ModuleIconComponent } from './moduleIconTypes'
import {
  AArrowDown,
  AArrowUp,
  ALargeSmall,
  Accessibility,
  Activity,
  Ad,
  AirVent,
  Airplay,
  AlarmClock,
  AlarmClockCheck,
  AlarmClockMinus,
  AlarmClockOff,
  AlarmClockPlus,
  AlarmSmoke,
  Album,
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignHorizontalDistributeCenter,
  AlignHorizontalDistributeEnd,
  AlignHorizontalDistributeStart,
  AlignHorizontalJustifyCenter,
  AlignHorizontalJustifyEnd,
  AlignHorizontalJustifyStart,
  AlignHorizontalSpaceAround,
  AlignHorizontalSpaceBetween,
  AlignStartHorizontal,
  AlignStartVertical,
  AlignVerticalDistributeCenter,
  AlignVerticalDistributeEnd,
  AlignVerticalDistributeStart,
  AlignVerticalJustifyCenter,
  AlignVerticalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalSpaceAround,
  AlignVerticalSpaceBetween,
  Ambulance,
  Ampersand,
  Ampersands,
  Amphora,
  Anchor,
  Angry,
  Annoyed,
  Antenna,
  Anvil,
  Aperture,
  AppWindow,
  AppWindowMac,
  Apple,
  Archive,
  ArchiveRestore,
  ArchiveX,
  Armchair,
  ArrowBigDown,
  ArrowBigDownDash,
  ArrowBigLeft,
  ArrowBigLeftDash,
  ArrowBigRight,
  ArrowBigRightDash,
  ArrowBigUp,
  ArrowBigUpDash,
  ArrowDown,
  ArrowDown01,
  ArrowDown10,
  ArrowDownAZ,
  ArrowDownFromLine,
  ArrowDownLeft,
  ArrowDownNarrowWide,
  ArrowDownRight,
  ArrowDownToDot,
  ArrowDownToLine,
  ArrowDownUp,
  ArrowDownWideNarrow,
  ArrowDownZA,
  ArrowLeft,
  ArrowLeftFromLine,
  ArrowLeftRight,
  ArrowLeftToLine,
  ArrowRight,
  ArrowRightFromLine,
  ArrowRightLeft,
  ArrowRightToLine,
  ArrowUp,
  ArrowUp01,
  ArrowUp10,
  ArrowUpAZ,
  ArrowUpDown,
  ArrowUpFromDot,
  ArrowUpFromLine,
  ArrowUpLeft,
  ArrowUpNarrowWide,
  ArrowUpRight,
  ArrowUpToLine,
  ArrowUpWideNarrow,
  ArrowUpZA,
  ArrowsUpFromLine,
  Asterisk,
  Astroid,
  AtSign,
  Atom,
  AudioLines,
  AudioWaveform,
  Award,
  Axe,
  Axis3d,
  Baby,
  Backpack,
  Badge,
  BadgeAlert,
  BadgeCent,
  BadgeCheck,
  BadgeDollarSign,
  BadgeEuro,
  BadgeIndianRupee,
  BadgeInfo,
  BadgeJapaneseYen,
  BadgeMinus,
  BadgePercent,
  BadgePlus,
  BadgePoundSterling,
  BadgeQuestionMark,
  BadgeRussianRuble,
  BadgeSwissFranc,
  BadgeTurkishLira,
  BadgeX,
  BaggageClaim,
  Balloon,
  Ban,
  Banana,
  Bandage,
  Banknote,
  BanknoteArrowDown,
  BanknoteArrowUp,
  BanknoteCheck,
  BanknoteX,
  Barcode,
  Barrel,
  Baseline,
  Bath,
  Battery,
  BatteryCharging,
  BatteryFull,
  BatteryLow,
  BatteryMedium,
  BatteryPlus,
  BatteryWarning,
  Beaker,
  Bean,
  BeanOff,
  Bed,
  BedDouble,
  BedSingle,
  Beef,
  BeefOff,
  Beer,
  BeerOff,
  Bell,
  BellCheck,
  BellDot,
  BellElectric,
  BellMinus,
  BellOff,
  BellPlus,
  BellRing,
  BetweenHorizontalEnd,
  BetweenHorizontalStart,
  BetweenVerticalEnd,
  BetweenVerticalStart,
  BicepsFlexed,
  Bike,
  Binary,
  Binoculars,
  Biohazard,
  Bird,
  Birdhouse,
  Bitcoin,
  Blend,
  Blender,
  Blinds,
  Blocks,
  Bluetooth,
  BluetoothConnected,
  BluetoothOff,
  BluetoothSearching,
  Bold,
  Bolt,
  Bomb,
  Bone,
  BoneFracture,
  Book,
  BookA,
  BookAlert,
  BookAudio,
  BookCheck,
  BookCopy,
  BookDashed,
  BookDown,
  BookHeadphones,
  BookHeart,
  BookImage,
  BookKey,
  BookLock,
  BookMarked,
  BookMinus,
  BookOpen,
  BookOpenCheck,
  BookOpenText,
  BookPlus,
  BookSearch,
  BookText,
  BookType,
  BookUp,
  BookUp2,
  BookUser,
  BookX,
  Bookmark,
  BookmarkCheck,
  BookmarkMinus,
  BookmarkOff,
  BookmarkPlus,
  BookmarkX,
  BoomBox,
  Bot,
  BotMessageSquare,
  BotOff,
  BottleWine,
  BowArrow,
  Box,
  Boxes,
  Braces,
  Brackets,
  Brain,
  BrainCircuit,
  BrainCog,
  BrickWall,
  BrickWallFire,
  BrickWallShield,
  Briefcase,
  BriefcaseBusiness,
  BriefcaseConveyorBelt,
  BriefcaseMedical,
  BringToFront,
  Broccoli,
  Brush,
  BrushCleaning,
  Bubbles,
  Bug,
  BugOff,
  BugPlay,
  Building,
  Building2,
  Bus,
  BusFront,
  Cable,
  CableCar,
  Cake,
  CakeSlice,
  Calculator,
  Calendar,
  Calendar1,
  CalendarArrowDown,
  CalendarArrowUp,
  CalendarCheck,
  CalendarCheck2,
  CalendarClock,
  CalendarCog,
  CalendarDays,
  CalendarFold,
  CalendarHeart,
  CalendarMinus,
  CalendarMinus2,
  CalendarOff,
  CalendarPlus,
  CalendarPlus2,
  CalendarRange,
  CalendarSearch,
  CalendarSync,
  CalendarX,
  CalendarX2,
  Calendars,
  Camera,
  CameraOff,
  Candy,
  CandyCane,
  CandyOff,
  Cannabis,
  CannabisOff,
  Captions,
  CaptionsOff,
  Car,
  CarFront,
  CarTaxiFront,
  Caravan,
  CardSim,
  Carrot,
  CaseLower,
  CaseSensitive,
  CaseUpper,
  CassetteTape,
  Cast,
  Castle,
  Cat,
  Cctv,
  CctvOff,
  ChartArea,
  ChartBar,
  ChartBarBig,
  ChartBarDecreasing,
  ChartBarIncreasing,
  ChartBarStacked,
  ChartCandlestick,
  ChartColumn,
  ChartColumnBig,
  ChartColumnDecreasing,
  ChartColumnIncreasing,
  ChartColumnStacked,
  ChartGantt,
  ChartLine,
  ChartNetwork,
  ChartNoAxesColumn,
  ChartNoAxesColumnDecreasing,
  ChartNoAxesColumnIncreasing,
  ChartNoAxesCombined,
  ChartNoAxesGantt,
  ChartPie,
  ChartScatter,
  ChartSpline,
  Check,
  CheckCheck,
  CheckLine,
  ChefHat,
  Cherry,
  ChessBishop,
  ChessKing,
  ChessKnight,
  ChessPawn,
  ChessQueen,
  ChessRook,
  ChevronDown,
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsDownUp,
  ChevronsLeft,
  ChevronsLeftRight,
  ChevronsLeftRightEllipsis,
  ChevronsRight,
  ChevronsRightLeft,
  ChevronsUp,
  ChevronsUpDown,
  Church,
  Cigarette,
  CigaretteOff,
  Circle,
  CircleAlert,
  CircleArrowDown,
  CircleArrowLeft,
  CircleArrowOutDownLeft,
  CircleArrowOutDownRight,
  CircleArrowOutUpLeft,
  CircleArrowOutUpRight,
  CircleArrowRight,
  CircleArrowUp,
  CircleCheck,
  CircleCheckBig,
  CircleChevronDown,
  CircleChevronLeft,
  CircleChevronRight,
  CircleChevronUp,
  CircleDashed,
  CircleDivide,
  CircleDollarSign,
  CircleDot,
  CircleDotDashed,
  CircleEllipsis,
  CircleEqual,
  CircleEuroSign,
  CircleFadingArrowUp,
  CircleFadingPlus,
  CircleGauge,
  CircleMinus,
  CircleOff,
  CircleParking,
  CircleParkingOff,
  CirclePause,
  CirclePercent,
  CirclePile,
  CirclePlay,
  CirclePlus,
  CirclePoundSterling,
  CirclePower,
  CircleQuestionMark,
  CircleSlash,
  CircleSlash2,
  CircleSmall,
  CircleStar,
  CircleStop,
  CircleUser,
  CircleUserRound,
  CircleX,
  CircuitBoard,
  Citrus,
  Clapperboard,
  Clipboard,
  ClipboardCheck,
  ClipboardClock,
  ClipboardCopy,
  ClipboardList,
  ClipboardMinus,
  ClipboardPaste,
  ClipboardPen,
  ClipboardPenLine,
  ClipboardPlus,
  ClipboardType,
  ClipboardX,
  Clock,
  Clock1,
  Clock10,
  Clock11,
  Clock12,
  Clock2,
  Clock3,
  Clock4,
  Clock5,
  Clock6,
  Clock7,
  Clock8,
  Clock9,
  ClockAlert,
  ClockArrowDown,
  ClockArrowLeft,
  ClockArrowRight,
  ClockArrowUp,
  ClockCheck,
  ClockFading,
  ClockPlus,
  ClosedCaption,
  Cloud,
  CloudAlert,
  CloudBackup,
  CloudCheck,
  CloudCog,
  CloudDownload,
  CloudDrizzle,
  CloudFog,
  CloudHail,
  CloudLightning,
  CloudMoon,
  CloudMoonRain,
  CloudOff,
  CloudRain,
  CloudRainWind,
  CloudSnow,
  CloudSun,
  CloudSunRain,
  CloudSync,
  CloudUpload,
  Cloudy,
  Clover,
  Club,
  Code,
  CodeXml,
  Coffee,
  Cog,
  Coins,
  Columns2,
  Columns3,
  Columns3Cog,
  Columns4,
  Combine,
  Command,
  Compass,
  Component,
  Computer,
  ConciergeBell,
  Cone,
  Construction,
  Contact,
  ContactRound,
  Container,
  Contrast,
  Cookie,
  CookingPot,
  Copy,
  CopyCheck,
  CopyMinus,
  CopyPlus,
  CopySlash,
  CopyX,
  Copyleft,
  Copyright,
  CornerDownLeft,
  CornerDownRight,
  CornerLeftDown,
  CornerLeftUp,
  CornerRightDown,
  CornerRightUp,
  CornerUpLeft,
  CornerUpRight,
  Cpu,
  CreativeCommons,
  CreditCard,
  Croissant,
  Crop,
  Cross,
  Crosshair,
  Crown,
  Cuboid,
  CupSoda,
  Currency,
  Cylinder,
  Dam,
  Database,
  DatabaseArrowDown,
  DatabaseArrowUp,
  DatabaseBackup,
  DatabaseCheck,
  DatabaseMinus,
  DatabasePlus,
  DatabaseSearch,
  DatabaseX,
  DatabaseZap,
  DecimalsArrowLeft,
  DecimalsArrowRight,
  Delete,
  Dessert,
  Diameter,
  Diamond,
  DiamondMinus,
  DiamondPercent,
  DiamondPlus,
  Dice1,
  Dice2,
  Dice3,
  Dice4,
  Dice5,
  Dice6,
  Dices,
  Diff,
  Disc,
  Disc2,
  Disc3,
  DiscAlbum,
  Divide,
  Dna,
  DnaOff,
  Dock,
  Dog,
  DollarSign,
  Donut,
  DoorClosed,
  DoorClosedLocked,
  DoorOpen,
  Dot,
  Download,
  DraftingCompass,
  Drama,
  Drill,
  Drone,
  Droplet,
  DropletOff,
  Droplets,
  Drum,
  Drumstick,
  Dumbbell,
  Ear,
  EarOff,
  Earth,
  EarthLock,
  Eclipse,
  Egg,
  EggFried,
  EggOff,
  Ellipse,
  Ellipsis,
  EllipsisVertical,
  Equal,
  EqualApproximately,
  EqualNot,
  Eraser,
  EthernetPort,
  Euro,
  EvCharger,
  Expand,
  ExternalLink,
  Eye,
  EyeClosed,
  EyeDashed,
  EyeOff,
  Factory,
  Fan,
  FastForward,
  Feather,
  Fence,
  FerrisWheel,
  File,
  FileArchive,
  FileAxis3d,
  FileBadge,
  FileBox,
  FileBraces,
  FileBracesCorner,
  FileChartColumn,
  FileChartColumnIncreasing,
  FileChartLine,
  FileChartPie,
  FileCheck,
  FileCheckCorner,
  FileClock,
  FileCode,
  FileCodeCorner,
  FileCog,
  FileDiff,
  FileDigit,
  FileDown,
  FileExclamationPoint,
  FileHeadphone,
  FileHeart,
  FileImage,
  FileInput,
  FileKey,
  FileLock,
  FileMinus,
  FileMinusCorner,
  FileMusic,
  FileOutput,
  FilePen,
  FilePenLine,
  FilePlay,
  FilePlus,
  FilePlusCorner,
  FileQuestionMark,
  FileScan,
  FileSearch,
  FileSearchCorner,
  FileSignal,
  FileSliders,
  FileSpreadsheet,
  FileStack,
  FileSymlink,
  FileTerminal,
  FileText,
  FileType,
  FileTypeCorner,
  FileUp,
  FileUser,
  FileVideoCamera,
  FileVolume,
  FileX,
  FileXCorner,
  Files,
  Film,
  FingerprintPattern,
  FireExtinguisher,
  Fish,
  FishOff,
  FishSymbol,
  FishingHook,
  FishingRod,
  Flag,
  FlagOff,
  FlagTriangleLeft,
  FlagTriangleRight,
  Flame,
  FlameKindling,
  Flashlight,
  FlashlightOff,
  FlaskConical,
  FlaskConicalOff,
  FlaskRound,
  FlipHorizontal2,
  FlipVertical2,
  Flower,
  Flower2,
  Focus,
  FoldHorizontal,
  FoldVertical,
  Folder,
  FolderArchive,
  FolderBookmark,
  FolderCheck,
  FolderClock,
  FolderClosed,
  FolderCode,
  FolderCog,
  FolderDot,
  FolderDown,
  FolderGit,
  FolderGit2,
  FolderHeart,
  FolderInput,
  FolderKanban,
  FolderKey,
  FolderLock,
  FolderMinus,
  FolderOpen,
  FolderOpenDot,
  FolderOutput,
  FolderPen,
  FolderPlus,
  FolderRoot,
  FolderSearch,
  FolderSearch2,
  FolderSymlink,
  FolderSync,
  FolderTree,
  FolderUp,
  FolderX,
  Folders,
  Footprints,
  Forklift,
  Form,
  Forward,
  Frame,
  Frown,
  Fuel,
  Fullscreen,
  Funnel,
  FunnelPlus,
  FunnelX,
  GalleryHorizontal,
  GalleryHorizontalEnd,
  GalleryThumbnails,
  GalleryVertical,
  GalleryVerticalEnd,
  Gamepad,
  Gamepad2,
  GamepadDirectional,
  Gauge,
  Gavel,
  Gem,
  GeorgianLari,
  Ghost,
  Gift,
  GitBranch,
  GitBranchMinus,
  GitBranchPlus,
  GitCommitHorizontal,
  GitCommitVertical,
  GitCompare,
  GitCompareArrows,
  GitFork,
  GitGraph,
  GitMerge,
  GitMergeConflict,
  GitPullRequest,
  GitPullRequestArrow,
  GitPullRequestClosed,
  GitPullRequestCreate,
  GitPullRequestCreateArrow,
  GitPullRequestDraft,
  GlassWater,
  Glasses,
  Globe,
  GlobeCheck,
  GlobeLock,
  GlobeOff,
  GlobeX,
  Goal,
  Gpu,
  GraduationCap,
  Grape,
  Grid2x2,
  Grid2x2Check,
  Grid2x2Plus,
  Grid2x2X,
  Grid3x2,
  Grid3x3,
  Grip,
  GripHorizontal,
  GripVertical,
  Group,
  Guitar,
  Ham,
  Hamburger,
  Hammer,
  Hand,
  HandCoins,
  HandFist,
  HandGrab,
  HandHeart,
  HandHelping,
  HandMetal,
  HandPlatter,
  Handbag,
  Handshake,
  HardDrive,
  HardDriveDownload,
  HardDriveUpload,
  HardHat,
  Hash,
  HatGlasses,
  Haze,
  Hd,
  HdmiPort,
  Heading,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  HeadphoneOff,
  Headphones,
  Headset,
  Heart,
  HeartCrack,
  HeartHandshake,
  HeartMinus,
  HeartOff,
  HeartPlus,
  HeartPulse,
  HeartX,
  Heater,
  Helicopter,
  Hexagon,
  Highlighter,
  History,
  Hop,
  HopOff,
  Hospital,
  Hotel,
  Hourglass,
  House,
  HouseHeart,
  HousePlug,
  HousePlus,
  HouseWifi,
  IceCreamBowl,
  IceCreamCone,
  IdCard,
  IdCardLanyard,
  Image,
  ImageDown,
  ImageMinus,
  ImageOff,
  ImagePlay,
  ImagePlus,
  ImageUp,
  ImageUpscale,
  Images,
  Import,
  Inbox,
  IndianRupee,
  Infinity,
  Info,
  InspectionPanel,
  Italic,
  IterationCcw,
  IterationCw,
  JapaneseYen,
  Joystick,
  Kanban,
  Kayak,
  Key,
  KeyRound,
  KeySquare,
  Keyboard,
  KeyboardMusic,
  KeyboardOff,
  Lamp,
  LampCeiling,
  LampDesk,
  LampFloor,
  LampWallDown,
  LampWallUp,
  LandPlot,
  Landmark,
  Languages,
  Laptop,
  LaptopMinimal,
  LaptopMinimalCheck,
  Lasso,
  LassoSelect,
  Laugh,
  Layers,
  Layers2,
  LayersMinus,
  LayersPlus,
  LayoutDashboard,
  LayoutGrid,
  LayoutList,
  LayoutPanelLeft,
  LayoutPanelTop,
  LayoutTemplate,
  Leaf,
  LeafyGreen,
  Lectern,
  LensConcave,
  LensConvex,
  Library,
  LibraryBig,
  LifeBuoy,
  Ligature,
  Lightbulb,
  LightbulbOff,
  LineDotRightHorizontal,
  LineSquiggle,
  LineStyle,
  Link,
  Link2,
  Link2Off,
  List,
  ListCheck,
  ListChecks,
  ListChevronsDownUp,
  ListChevronsUpDown,
  ListCollapse,
  ListEnd,
  ListFilter,
  ListFilterPlus,
  ListIndentDecrease,
  ListIndentIncrease,
  ListMinus,
  ListMusic,
  ListOrdered,
  ListPlus,
  ListRestart,
  ListSortAscending,
  ListSortDescending,
  ListStart,
  ListTodo,
  ListTree,
  ListVideo,
  ListX,
  Loader,
  LoaderCircle,
  LoaderPinwheel,
  Locate,
  LocateFixed,
  LocateOff,
  Lock,
  LockKeyhole,
  LockKeyholeOpen,
  LockOpen,
  LogIn,
  LogOut,
  Logs,
  Lollipop,
  Luggage,
  Magnet,
  Mail,
  MailCheck,
  MailMinus,
  MailOpen,
  MailPlus,
  MailQuestionMark,
  MailSearch,
  MailWarning,
  MailX,
  Mailbox,
  Mails,
  Map,
  MapMinus,
  MapPin,
  MapPinCheck,
  MapPinCheckInside,
  MapPinHouse,
  MapPinMinus,
  MapPinMinusInside,
  MapPinOff,
  MapPinPen,
  MapPinPlus,
  MapPinPlusInside,
  MapPinSearch,
  MapPinX,
  MapPinXInside,
  MapPinned,
  MapPlus,
  Mars,
  MarsStroke,
  Martini,
  Maximize,
  Maximize2,
  Medal,
  Megaphone,
  MegaphoneOff,
  Meh,
  MemoryStick,
  Menu,
  Merge,
  MessageCircle,
  MessageCircleCheck,
  MessageCircleCode,
  MessageCircleDashed,
  MessageCircleHeart,
  MessageCircleMore,
  MessageCircleOff,
  MessageCirclePlus,
  MessageCircleQuestionMark,
  MessageCircleReply,
  MessageCircleWarning,
  MessageCircleX,
  MessageSquare,
  MessageSquareCheck,
  MessageSquareCode,
  MessageSquareDashed,
  MessageSquareDiff,
  MessageSquareDot,
  MessageSquareHeart,
  MessageSquareLock,
  MessageSquareMore,
  MessageSquareOff,
  MessageSquarePlus,
  MessageSquareQuote,
  MessageSquareReply,
  MessageSquareShare,
  MessageSquareText,
  MessageSquareWarning,
  MessageSquareX,
  MessagesSquare,
  Metronome,
  Mic,
  MicOff,
  MicVocal,
  Microchip,
  Microscope,
  Microwave,
  Milestone,
  Milk,
  MilkOff,
  Minimize,
  Minimize2,
  Minus,
  MirrorRectangular,
  MirrorRound,
  Monitor,
  MonitorCheck,
  MonitorCloud,
  MonitorCog,
  MonitorDot,
  MonitorDown,
  MonitorOff,
  MonitorPause,
  MonitorPlay,
  MonitorSmartphone,
  MonitorSpeaker,
  MonitorStop,
  MonitorUp,
  MonitorX,
  Moon,
  MoonStar,
  Motorbike,
  Mountain,
  MountainSnow,
  Mouse,
  MouseLeft,
  MouseOff,
  MousePointer,
  MousePointer2,
  MousePointer2Off,
  MousePointerBan,
  MousePointerClick,
  MouseRight,
  Move,
  Move3d,
  MoveDiagonal,
  MoveDiagonal2,
  MoveDown,
  MoveDownLeft,
  MoveDownRight,
  MoveHorizontal,
  MoveLeft,
  MoveRight,
  MoveUp,
  MoveUpLeft,
  MoveUpRight,
  MoveVertical,
  Music,
  Music2,
  Music3,
  Music4,
  Navigation,
  Navigation2,
  Navigation2Off,
  NavigationOff,
  Network,
  Newspaper,
  Nfc,
  NonBinary,
  Notebook,
  NotebookPen,
  NotebookTabs,
  NotebookText,
  NotepadText,
  NotepadTextDashed,
  Nut,
  NutOff,
  Octagon,
  OctagonAlert,
  OctagonMinus,
  OctagonPause,
  OctagonX,
  Omega,
  Option,
  Orbit,
  Origami,
  Package,
  Package2,
  PackageCheck,
  PackageMinus,
  PackageOpen,
  PackagePlus,
  PackageSearch,
  PackageX,
  PaintBucket,
  PaintRoller,
  Paintbrush,
  PaintbrushVertical,
  Palette,
  Panda,
  PanelBottom,
  PanelBottomClose,
  PanelBottomDashed,
  PanelBottomOpen,
  PanelLeft,
  PanelLeftClose,
  PanelLeftDashed,
  PanelLeftOpen,
  PanelLeftRightDashed,
  PanelRight,
  PanelRightClose,
  PanelRightDashed,
  PanelRightOpen,
  PanelTop,
  PanelTopBottomDashed,
  PanelTopClose,
  PanelTopDashed,
  PanelTopOpen,
  PanelsLeftBottom,
  PanelsRightBottom,
  PanelsTopLeft,
  PaperBag,
  Paperclip,
  Parasol,
  Parentheses,
  ParkingMeter,
  PartyPopper,
  Pause,
  PawPrint,
  PcCase,
  Pen,
  PenLine,
  PenOff,
  PenTool,
  Pencil,
  PencilLine,
  PencilOff,
  PencilRuler,
  PencilSparkles,
  Pentagon,
  Percent,
  PersonStanding,
  Phi,
  PhilippinePeso,
  Phone,
  PhoneCall,
  PhoneForwarded,
  PhoneIncoming,
  PhoneMissed,
  PhoneOff,
  PhoneOutgoing,
  Pi,
  Piano,
  Pickaxe,
  PictureInPicture,
  PictureInPicture2,
  PiggyBank,
  Pilcrow,
  PilcrowLeft,
  PilcrowRight,
  Pill,
  PillBottle,
  Pin,
  PinOff,
  Pipette,
  Pizza,
  Plane,
  PlaneLanding,
  PlaneTakeoff,
  Play,
  PlayOff,
  Plug,
  Plug2,
  PlugZap,
  Plus,
  PocketKnife,
  Podcast,
  Podium,
  Pointer,
  PointerOff,
  Popcorn,
  Popsicle,
  PoundSterling,
  Power,
  PowerOff,
  Presentation,
  Printer,
  PrinterCheck,
  PrinterX,
  Projector,
  Proportions,
  Puzzle,
  Pyramid,
  QrCode,
  Quote,
  Rabbit,
  Radar,
  Radiation,
  Radical,
  Radio,
  RadioOff,
  RadioReceiver,
  RadioTower,
  Radius,
  Rainbow,
  Rat,
  Ratio,
  Receipt,
  ReceiptCent,
  ReceiptEuro,
  ReceiptIndianRupee,
  ReceiptJapaneseYen,
  ReceiptPoundSterling,
  ReceiptRussianRuble,
  ReceiptSwissFranc,
  ReceiptText,
  ReceiptTurkishLira,
  RectangleCircle,
  RectangleEllipsis,
  RectangleGoggles,
  RectangleHorizontal,
  RectangleVertical,
  Recycle,
  Redo,
  Redo2,
  RedoDot,
  RefreshCcw,
  RefreshCcwDot,
  RefreshCw,
  RefreshCwOff,
  Refrigerator,
  Regex,
  RemoveFormatting,
  Repeat,
  Repeat1,
  Repeat2,
  RepeatOff,
  Replace,
  ReplaceAll,
  Reply,
  ReplyAll,
  Rewind,
  Ribbon,
  Road,
  Rocket,
  RockingChair,
  RollerCoaster,
  Rose,
  Rotate3d,
  RotateCcw,
  RotateCcwKey,
  RotateCcwSquare,
  RotateCw,
  RotateCwSquare,
  Route,
  RouteOff,
  Router,
  Rows2,
  Rows3,
  Rows4,
  Rss,
  Ruler,
  RulerDimensionLine,
  RussianRuble,
  Sailboat,
  Salad,
  Sandwich,
  Satellite,
  SatelliteDish,
  SaudiRiyal,
  Save,
  SaveAll,
  SaveCheck,
  SaveOff,
  SavePen,
  SavePlus,
  Scale,
  Scale3d,
  Scaling,
  Scan,
  ScanBarcode,
  ScanEye,
  ScanFace,
  ScanHeart,
  ScanLine,
  ScanQrCode,
  ScanSearch,
  ScanText,
  School,
  Scissors,
  ScissorsLineDashed,
  Scooter,
  ScreenShare,
  ScreenShareOff,
  Scroll,
  ScrollText,
  Search,
  SearchAlert,
  SearchCheck,
  SearchCode,
  SearchSlash,
  SearchX,
  Section,
  Send,
  SendHorizontal,
  SendToBack,
  SeparatorHorizontal,
  SeparatorVertical,
  Server,
  ServerCog,
  ServerCrash,
  ServerOff,
  Settings,
  Settings2,
  Shapes,
  Share,
  Share2,
  Sheet,
  Shell,
  ShelvingUnit,
  Shield,
  ShieldAlert,
  ShieldBan,
  ShieldCheck,
  ShieldCog,
  ShieldCogCorner,
  ShieldEllipsis,
  ShieldHalf,
  ShieldMinus,
  ShieldOff,
  ShieldPlus,
  ShieldQuestionMark,
  ShieldUser,
  ShieldX,
  Ship,
  ShipWheel,
  Shirt,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCart,
  Shovel,
  ShowerHead,
  Shredder,
  Shrimp,
  Shrink,
  Shrub,
  Shuffle,
  Sigma,
  Signal,
  SignalHigh,
  SignalLow,
  SignalMedium,
  SignalZero,
  Signature,
  Signpost,
  SignpostBig,
  Siren,
  SkipBack,
  SkipForward,
  Skull,
  Slash,
  Slice,
  SlidersHorizontal,
  SlidersVertical,
  Smartphone,
  SmartphoneCharging,
  SmartphoneNfc,
  Smile,
  SmilePlus,
  Snail,
  Snowflake,
  SoapDispenserDroplet,
  Sofa,
  SolarPanel,
  Soup,
  Space,
  Spade,
  Sparkle,
  Sparkles,
  Speaker,
  Speech,
  SpellCheck,
  SpellCheck2,
  Spline,
  SplinePointer,
  Split,
  Spool,
  SportShoe,
  Spotlight,
  SprayCan,
  Sprout,
  Square,
  SquareActivity,
  SquareArrowDown,
  SquareArrowDownLeft,
  SquareArrowDownRight,
  SquareArrowLeft,
  SquareArrowOutDownLeft,
  SquareArrowOutDownRight,
  SquareArrowOutUpLeft,
  SquareArrowOutUpRight,
  SquareArrowRight,
  SquareArrowRightEnter,
  SquareArrowRightExit,
  SquareArrowUp,
  SquareArrowUpLeft,
  SquareArrowUpRight,
  SquareAsterisk,
  SquareBottomDashedScissors,
  SquareCenterlineDashedHorizontal,
  SquareCenterlineDashedVertical,
  SquareChartGantt,
  SquareCheck,
  SquareCheckBig,
  SquareChevronDown,
  SquareChevronLeft,
  SquareChevronRight,
  SquareChevronUp,
  SquareCode,
  SquareDashed,
  SquareDashedBottom,
  SquareDashedBottomCode,
  SquareDashedKanban,
  SquareDashedMousePointer,
  SquareDashedText,
  SquareDashedTopSolid,
  SquareDivide,
  SquareDot,
  SquareEqual,
  SquareFunction,
  SquareKanban,
  SquareLibrary,
  SquareM,
  SquareMenu,
  SquareMinus,
  SquareMousePointer,
  SquareParking,
  SquareParkingOff,
  SquarePause,
  SquarePen,
  SquarePercent,
  SquarePi,
  SquarePilcrow,
  SquarePlay,
  SquarePlus,
  SquarePower,
  SquareRadical,
  SquareRoundCorner,
  SquareScissors,
  SquareSigma,
  SquareSlash,
  SquareSplitHorizontal,
  SquareSplitVertical,
  SquareSquare,
  SquareStack,
  SquareStar,
  SquareStop,
  SquareTerminal,
  SquareUser,
  SquareUserRound,
  SquareX,
  SquaresExclude,
  SquaresIntersect,
  SquaresSubtract,
  SquaresUnite,
  Squircle,
  SquircleDashed,
  Squirrel,
  Stamp,
  Star,
  StarCheck,
  StarHalf,
  StarMinus,
  StarOff,
  StarPlus,
  StarX,
  StepBack,
  StepForward,
  Stethoscope,
  Sticker,
  StickyNote,
  StickyNoteCheck,
  StickyNoteMinus,
  StickyNoteOff,
  StickyNotePlus,
  StickyNoteX,
  StickyNotes,
  Stone,
  Store,
  StretchHorizontal,
  StretchVertical,
  Strikethrough,
  Subscript,
  Summary,
  Sun,
  SunDim,
  SunMedium,
  SunMoon,
  SunSnow,
  Sunrise,
  Sunset,
  Superscript,
  SwatchBook,
  SwissFranc,
  SwitchCamera,
  Sword,
  Swords,
  Syringe,
  Table,
  Table2,
  TableCellsMerge,
  TableCellsSplit,
  TableColumnsSplit,
  TableOfContents,
  TableProperties,
  TableRowsSplit,
  Tablet,
  TabletSmartphone,
  Tablets,
  Tag,
  TagPlus,
  TagX,
  Tags,
  Tally1,
  Tally2,
  Tally3,
  Tally4,
  Tally5,
  Tangent,
  Target,
  Telescope,
  Tent,
  TentTree,
  Terminal,
  TestTube,
  TestTubeDiagonal,
  TestTubes,
  TextAlignCenter,
  TextAlignEnd,
  TextAlignJustify,
  TextAlignStart,
  TextCursor,
  TextCursorInput,
  TextInitial,
  TextQuote,
  TextSearch,
  TextWrap,
  Theater,
  Thermometer,
  ThermometerSnowflake,
  ThermometerSun,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  TicketCheck,
  TicketMinus,
  TicketPercent,
  TicketPlus,
  TicketSlash,
  TicketX,
  Tickets,
  TicketsPlane,
  Timeline,
  Timer,
  TimerOff,
  TimerReset,
  ToggleLeft,
  ToggleRight,
  Toilet,
  ToolCase,
  Toolbox,
  Tornado,
  Torus,
  Touchpad,
  TouchpadOff,
  TowelRack,
  TowerControl,
  ToyBrick,
  Tractor,
  TrafficCone,
  TrainFront,
  TrainFrontTunnel,
  TrainTrack,
  TramFront,
  Transgender,
  Trash,
  Trash2,
  TreeDeciduous,
  TreePalm,
  TreePine,
  Trees,
  TrendingDown,
  TrendingUp,
  TrendingUpDown,
  Triangle,
  TriangleAlert,
  TriangleDashed,
  TriangleRight,
  Trophy,
  Truck,
  TruckElectric,
  TurkishLira,
  Turntable,
  Turtle,
  Tv,
  TvMinimal,
  TvMinimalPlay,
  Type,
  TypeOutline,
  Umbrella,
  UmbrellaOff,
  Underline,
  Undo,
  Undo2,
  UndoDot,
  UnfoldHorizontal,
  UnfoldVertical,
  Ungroup,
  University,
  Unlink,
  Unlink2,
  Unplug,
  Upload,
  Usb,
  User,
  UserCheck,
  UserCog,
  UserKey,
  UserLock,
  UserMinus,
  UserPen,
  UserPlus,
  UserRound,
  UserRoundArrowLeft,
  UserRoundCheck,
  UserRoundCog,
  UserRoundKey,
  UserRoundMinus,
  UserRoundPen,
  UserRoundPlus,
  UserRoundSearch,
  UserRoundX,
  UserSearch,
  UserStar,
  UserX,
  Users,
  UsersRound,
  Utensils,
  UtensilsCrossed,
  UtilityPole,
  Van,
  Variable,
  Vault,
  VectorSquare,
  Vegan,
  VenetianMask,
  Venus,
  VenusAndMars,
  Vibrate,
  VibrateOff,
  Video,
  VideoOff,
  Videotape,
  View,
  Voicemail,
  Volleyball,
  Volume,
  Volume1,
  Volume2,
  VolumeOff,
  VolumeX,
  Vote,
  Wallet,
  WalletCards,
  WalletMinimal,
  Wallpaper,
  Wand,
  WandSparkles,
  Warehouse,
  WashingMachine,
  Watch,
  WavesArrowDown,
  WavesArrowUp,
  WavesHorizontal,
  WavesLadder,
  WavesVertical,
  Waypoints,
  Webcam,
  WebcamOff,
  Webhook,
  WebhookOff,
  Weight,
  WeightTilde,
  Wheat,
  WheatOff,
  WholeWord,
  Wifi,
  WifiCog,
  WifiHigh,
  WifiLow,
  WifiOff,
  WifiPen,
  WifiSync,
  WifiZero,
  Wind,
  WindArrowDown,
  Wine,
  WineOff,
  Workflow,
  Worm,
  Wrench,
  WrenchOff,
  X,
  XLineTop,
  Zap,
  ZapOff,
  ZodiacAquarius,
  ZodiacAries,
  ZodiacCancer,
  ZodiacCapricorn,
  ZodiacGemini,
  ZodiacLeo,
  ZodiacLibra,
  ZodiacOphiuchus,
  ZodiacPisces,
  ZodiacSagittarius,
  ZodiacScorpio,
  ZodiacTaurus,
  ZodiacVirgo,
  ZoomIn,
  ZoomOut,
} from 'lucide-react'

/** Mapa nome (salvo no banco) → componente Lucide. Prefixo `lucide-` evita conflito com Heroicons. */
export const MODULE_LUCIDE_ICON_MAP: Record<string, ModuleIconComponent> = {
  'lucide-a-arrow-down': AArrowDown,
  'lucide-a-arrow-up': AArrowUp,
  'lucide-a-large-small': ALargeSmall,
  'lucide-accessibility': Accessibility,
  'lucide-activity': Activity,
  'lucide-ad': Ad,
  'lucide-air-vent': AirVent,
  'lucide-airplay': Airplay,
  'lucide-alarm-clock': AlarmClock,
  'lucide-alarm-clock-check': AlarmClockCheck,
  'lucide-alarm-clock-minus': AlarmClockMinus,
  'lucide-alarm-clock-off': AlarmClockOff,
  'lucide-alarm-clock-plus': AlarmClockPlus,
  'lucide-alarm-smoke': AlarmSmoke,
  'lucide-album': Album,
  'lucide-align-center-horizontal': AlignCenterHorizontal,
  'lucide-align-center-vertical': AlignCenterVertical,
  'lucide-align-end-horizontal': AlignEndHorizontal,
  'lucide-align-end-vertical': AlignEndVertical,
  'lucide-align-horizontal-distribute-center': AlignHorizontalDistributeCenter,
  'lucide-align-horizontal-distribute-end': AlignHorizontalDistributeEnd,
  'lucide-align-horizontal-distribute-start': AlignHorizontalDistributeStart,
  'lucide-align-horizontal-justify-center': AlignHorizontalJustifyCenter,
  'lucide-align-horizontal-justify-end': AlignHorizontalJustifyEnd,
  'lucide-align-horizontal-justify-start': AlignHorizontalJustifyStart,
  'lucide-align-horizontal-space-around': AlignHorizontalSpaceAround,
  'lucide-align-horizontal-space-between': AlignHorizontalSpaceBetween,
  'lucide-align-start-horizontal': AlignStartHorizontal,
  'lucide-align-start-vertical': AlignStartVertical,
  'lucide-align-vertical-distribute-center': AlignVerticalDistributeCenter,
  'lucide-align-vertical-distribute-end': AlignVerticalDistributeEnd,
  'lucide-align-vertical-distribute-start': AlignVerticalDistributeStart,
  'lucide-align-vertical-justify-center': AlignVerticalJustifyCenter,
  'lucide-align-vertical-justify-end': AlignVerticalJustifyEnd,
  'lucide-align-vertical-justify-start': AlignVerticalJustifyStart,
  'lucide-align-vertical-space-around': AlignVerticalSpaceAround,
  'lucide-align-vertical-space-between': AlignVerticalSpaceBetween,
  'lucide-ambulance': Ambulance,
  'lucide-ampersand': Ampersand,
  'lucide-ampersands': Ampersands,
  'lucide-amphora': Amphora,
  'lucide-anchor': Anchor,
  'lucide-angry': Angry,
  'lucide-annoyed': Annoyed,
  'lucide-antenna': Antenna,
  'lucide-anvil': Anvil,
  'lucide-aperture': Aperture,
  'lucide-app-window': AppWindow,
  'lucide-app-window-mac': AppWindowMac,
  'lucide-apple': Apple,
  'lucide-archive': Archive,
  'lucide-archive-restore': ArchiveRestore,
  'lucide-archive-x': ArchiveX,
  'lucide-armchair': Armchair,
  'lucide-arrow-big-down': ArrowBigDown,
  'lucide-arrow-big-down-dash': ArrowBigDownDash,
  'lucide-arrow-big-left': ArrowBigLeft,
  'lucide-arrow-big-left-dash': ArrowBigLeftDash,
  'lucide-arrow-big-right': ArrowBigRight,
  'lucide-arrow-big-right-dash': ArrowBigRightDash,
  'lucide-arrow-big-up': ArrowBigUp,
  'lucide-arrow-big-up-dash': ArrowBigUpDash,
  'lucide-arrow-down': ArrowDown,
  'lucide-arrow-down01': ArrowDown01,
  'lucide-arrow-down10': ArrowDown10,
  'lucide-arrow-down-az': ArrowDownAZ,
  'lucide-arrow-down-from-line': ArrowDownFromLine,
  'lucide-arrow-down-left': ArrowDownLeft,
  'lucide-arrow-down-narrow-wide': ArrowDownNarrowWide,
  'lucide-arrow-down-right': ArrowDownRight,
  'lucide-arrow-down-to-dot': ArrowDownToDot,
  'lucide-arrow-down-to-line': ArrowDownToLine,
  'lucide-arrow-down-up': ArrowDownUp,
  'lucide-arrow-down-wide-narrow': ArrowDownWideNarrow,
  'lucide-arrow-down-za': ArrowDownZA,
  'lucide-arrow-left': ArrowLeft,
  'lucide-arrow-left-from-line': ArrowLeftFromLine,
  'lucide-arrow-left-right': ArrowLeftRight,
  'lucide-arrow-left-to-line': ArrowLeftToLine,
  'lucide-arrow-right': ArrowRight,
  'lucide-arrow-right-from-line': ArrowRightFromLine,
  'lucide-arrow-right-left': ArrowRightLeft,
  'lucide-arrow-right-to-line': ArrowRightToLine,
  'lucide-arrow-up': ArrowUp,
  'lucide-arrow-up01': ArrowUp01,
  'lucide-arrow-up10': ArrowUp10,
  'lucide-arrow-up-az': ArrowUpAZ,
  'lucide-arrow-up-down': ArrowUpDown,
  'lucide-arrow-up-from-dot': ArrowUpFromDot,
  'lucide-arrow-up-from-line': ArrowUpFromLine,
  'lucide-arrow-up-left': ArrowUpLeft,
  'lucide-arrow-up-narrow-wide': ArrowUpNarrowWide,
  'lucide-arrow-up-right': ArrowUpRight,
  'lucide-arrow-up-to-line': ArrowUpToLine,
  'lucide-arrow-up-wide-narrow': ArrowUpWideNarrow,
  'lucide-arrow-up-za': ArrowUpZA,
  'lucide-arrows-up-from-line': ArrowsUpFromLine,
  'lucide-asterisk': Asterisk,
  'lucide-astroid': Astroid,
  'lucide-at-sign': AtSign,
  'lucide-atom': Atom,
  'lucide-audio-lines': AudioLines,
  'lucide-audio-waveform': AudioWaveform,
  'lucide-award': Award,
  'lucide-axe': Axe,
  'lucide-axis3d': Axis3d,
  'lucide-baby': Baby,
  'lucide-backpack': Backpack,
  'lucide-badge': Badge,
  'lucide-badge-alert': BadgeAlert,
  'lucide-badge-cent': BadgeCent,
  'lucide-badge-check': BadgeCheck,
  'lucide-badge-dollar-sign': BadgeDollarSign,
  'lucide-badge-euro': BadgeEuro,
  'lucide-badge-indian-rupee': BadgeIndianRupee,
  'lucide-badge-info': BadgeInfo,
  'lucide-badge-japanese-yen': BadgeJapaneseYen,
  'lucide-badge-minus': BadgeMinus,
  'lucide-badge-percent': BadgePercent,
  'lucide-badge-plus': BadgePlus,
  'lucide-badge-pound-sterling': BadgePoundSterling,
  'lucide-badge-question-mark': BadgeQuestionMark,
  'lucide-badge-russian-ruble': BadgeRussianRuble,
  'lucide-badge-swiss-franc': BadgeSwissFranc,
  'lucide-badge-turkish-lira': BadgeTurkishLira,
  'lucide-badge-x': BadgeX,
  'lucide-baggage-claim': BaggageClaim,
  'lucide-balloon': Balloon,
  'lucide-ban': Ban,
  'lucide-banana': Banana,
  'lucide-bandage': Bandage,
  'lucide-banknote': Banknote,
  'lucide-banknote-arrow-down': BanknoteArrowDown,
  'lucide-banknote-arrow-up': BanknoteArrowUp,
  'lucide-banknote-check': BanknoteCheck,
  'lucide-banknote-x': BanknoteX,
  'lucide-barcode': Barcode,
  'lucide-barrel': Barrel,
  'lucide-baseline': Baseline,
  'lucide-bath': Bath,
  'lucide-battery': Battery,
  'lucide-battery-charging': BatteryCharging,
  'lucide-battery-full': BatteryFull,
  'lucide-battery-low': BatteryLow,
  'lucide-battery-medium': BatteryMedium,
  'lucide-battery-plus': BatteryPlus,
  'lucide-battery-warning': BatteryWarning,
  'lucide-beaker': Beaker,
  'lucide-bean': Bean,
  'lucide-bean-off': BeanOff,
  'lucide-bed': Bed,
  'lucide-bed-double': BedDouble,
  'lucide-bed-single': BedSingle,
  'lucide-beef': Beef,
  'lucide-beef-off': BeefOff,
  'lucide-beer': Beer,
  'lucide-beer-off': BeerOff,
  'lucide-bell': Bell,
  'lucide-bell-check': BellCheck,
  'lucide-bell-dot': BellDot,
  'lucide-bell-electric': BellElectric,
  'lucide-bell-minus': BellMinus,
  'lucide-bell-off': BellOff,
  'lucide-bell-plus': BellPlus,
  'lucide-bell-ring': BellRing,
  'lucide-between-horizontal-end': BetweenHorizontalEnd,
  'lucide-between-horizontal-start': BetweenHorizontalStart,
  'lucide-between-vertical-end': BetweenVerticalEnd,
  'lucide-between-vertical-start': BetweenVerticalStart,
  'lucide-biceps-flexed': BicepsFlexed,
  'lucide-bike': Bike,
  'lucide-binary': Binary,
  'lucide-binoculars': Binoculars,
  'lucide-biohazard': Biohazard,
  'lucide-bird': Bird,
  'lucide-birdhouse': Birdhouse,
  'lucide-bitcoin': Bitcoin,
  'lucide-blend': Blend,
  'lucide-blender': Blender,
  'lucide-blinds': Blinds,
  'lucide-blocks': Blocks,
  'lucide-bluetooth': Bluetooth,
  'lucide-bluetooth-connected': BluetoothConnected,
  'lucide-bluetooth-off': BluetoothOff,
  'lucide-bluetooth-searching': BluetoothSearching,
  'lucide-bold': Bold,
  'lucide-bolt': Bolt,
  'lucide-bomb': Bomb,
  'lucide-bone': Bone,
  'lucide-bone-fracture': BoneFracture,
  'lucide-book': Book,
  'lucide-book-a': BookA,
  'lucide-book-alert': BookAlert,
  'lucide-book-audio': BookAudio,
  'lucide-book-check': BookCheck,
  'lucide-book-copy': BookCopy,
  'lucide-book-dashed': BookDashed,
  'lucide-book-down': BookDown,
  'lucide-book-headphones': BookHeadphones,
  'lucide-book-heart': BookHeart,
  'lucide-book-image': BookImage,
  'lucide-book-key': BookKey,
  'lucide-book-lock': BookLock,
  'lucide-book-marked': BookMarked,
  'lucide-book-minus': BookMinus,
  'lucide-book-open': BookOpen,
  'lucide-book-open-check': BookOpenCheck,
  'lucide-book-open-text': BookOpenText,
  'lucide-book-plus': BookPlus,
  'lucide-book-search': BookSearch,
  'lucide-book-text': BookText,
  'lucide-book-type': BookType,
  'lucide-book-up': BookUp,
  'lucide-book-up2': BookUp2,
  'lucide-book-user': BookUser,
  'lucide-book-x': BookX,
  'lucide-bookmark': Bookmark,
  'lucide-bookmark-check': BookmarkCheck,
  'lucide-bookmark-minus': BookmarkMinus,
  'lucide-bookmark-off': BookmarkOff,
  'lucide-bookmark-plus': BookmarkPlus,
  'lucide-bookmark-x': BookmarkX,
  'lucide-boom-box': BoomBox,
  'lucide-bot': Bot,
  'lucide-bot-message-square': BotMessageSquare,
  'lucide-bot-off': BotOff,
  'lucide-bottle-wine': BottleWine,
  'lucide-bow-arrow': BowArrow,
  'lucide-box': Box,
  'lucide-boxes': Boxes,
  'lucide-braces': Braces,
  'lucide-brackets': Brackets,
  'lucide-brain': Brain,
  'lucide-brain-circuit': BrainCircuit,
  'lucide-brain-cog': BrainCog,
  'lucide-brick-wall': BrickWall,
  'lucide-brick-wall-fire': BrickWallFire,
  'lucide-brick-wall-shield': BrickWallShield,
  'lucide-briefcase': Briefcase,
  'lucide-briefcase-business': BriefcaseBusiness,
  'lucide-briefcase-conveyor-belt': BriefcaseConveyorBelt,
  'lucide-briefcase-medical': BriefcaseMedical,
  'lucide-bring-to-front': BringToFront,
  'lucide-broccoli': Broccoli,
  'lucide-brush': Brush,
  'lucide-brush-cleaning': BrushCleaning,
  'lucide-bubbles': Bubbles,
  'lucide-bug': Bug,
  'lucide-bug-off': BugOff,
  'lucide-bug-play': BugPlay,
  'lucide-building': Building,
  'lucide-building2': Building2,
  'lucide-bus': Bus,
  'lucide-bus-front': BusFront,
  'lucide-cable': Cable,
  'lucide-cable-car': CableCar,
  'lucide-cake': Cake,
  'lucide-cake-slice': CakeSlice,
  'lucide-calculator': Calculator,
  'lucide-calendar': Calendar,
  'lucide-calendar1': Calendar1,
  'lucide-calendar-arrow-down': CalendarArrowDown,
  'lucide-calendar-arrow-up': CalendarArrowUp,
  'lucide-calendar-check': CalendarCheck,
  'lucide-calendar-check2': CalendarCheck2,
  'lucide-calendar-clock': CalendarClock,
  'lucide-calendar-cog': CalendarCog,
  'lucide-calendar-days': CalendarDays,
  'lucide-calendar-fold': CalendarFold,
  'lucide-calendar-heart': CalendarHeart,
  'lucide-calendar-minus': CalendarMinus,
  'lucide-calendar-minus2': CalendarMinus2,
  'lucide-calendar-off': CalendarOff,
  'lucide-calendar-plus': CalendarPlus,
  'lucide-calendar-plus2': CalendarPlus2,
  'lucide-calendar-range': CalendarRange,
  'lucide-calendar-search': CalendarSearch,
  'lucide-calendar-sync': CalendarSync,
  'lucide-calendar-x': CalendarX,
  'lucide-calendar-x2': CalendarX2,
  'lucide-calendars': Calendars,
  'lucide-camera': Camera,
  'lucide-camera-off': CameraOff,
  'lucide-candy': Candy,
  'lucide-candy-cane': CandyCane,
  'lucide-candy-off': CandyOff,
  'lucide-cannabis': Cannabis,
  'lucide-cannabis-off': CannabisOff,
  'lucide-captions': Captions,
  'lucide-captions-off': CaptionsOff,
  'lucide-car': Car,
  'lucide-car-front': CarFront,
  'lucide-car-taxi-front': CarTaxiFront,
  'lucide-caravan': Caravan,
  'lucide-card-sim': CardSim,
  'lucide-carrot': Carrot,
  'lucide-case-lower': CaseLower,
  'lucide-case-sensitive': CaseSensitive,
  'lucide-case-upper': CaseUpper,
  'lucide-cassette-tape': CassetteTape,
  'lucide-cast': Cast,
  'lucide-castle': Castle,
  'lucide-cat': Cat,
  'lucide-cctv': Cctv,
  'lucide-cctv-off': CctvOff,
  'lucide-chart-area': ChartArea,
  'lucide-chart-bar': ChartBar,
  'lucide-chart-bar-big': ChartBarBig,
  'lucide-chart-bar-decreasing': ChartBarDecreasing,
  'lucide-chart-bar-increasing': ChartBarIncreasing,
  'lucide-chart-bar-stacked': ChartBarStacked,
  'lucide-chart-candlestick': ChartCandlestick,
  'lucide-chart-column': ChartColumn,
  'lucide-chart-column-big': ChartColumnBig,
  'lucide-chart-column-decreasing': ChartColumnDecreasing,
  'lucide-chart-column-increasing': ChartColumnIncreasing,
  'lucide-chart-column-stacked': ChartColumnStacked,
  'lucide-chart-gantt': ChartGantt,
  'lucide-chart-line': ChartLine,
  'lucide-chart-network': ChartNetwork,
  'lucide-chart-no-axes-column': ChartNoAxesColumn,
  'lucide-chart-no-axes-column-decreasing': ChartNoAxesColumnDecreasing,
  'lucide-chart-no-axes-column-increasing': ChartNoAxesColumnIncreasing,
  'lucide-chart-no-axes-combined': ChartNoAxesCombined,
  'lucide-chart-no-axes-gantt': ChartNoAxesGantt,
  'lucide-chart-pie': ChartPie,
  'lucide-chart-scatter': ChartScatter,
  'lucide-chart-spline': ChartSpline,
  'lucide-check': Check,
  'lucide-check-check': CheckCheck,
  'lucide-check-line': CheckLine,
  'lucide-chef-hat': ChefHat,
  'lucide-cherry': Cherry,
  'lucide-chess-bishop': ChessBishop,
  'lucide-chess-king': ChessKing,
  'lucide-chess-knight': ChessKnight,
  'lucide-chess-pawn': ChessPawn,
  'lucide-chess-queen': ChessQueen,
  'lucide-chess-rook': ChessRook,
  'lucide-chevron-down': ChevronDown,
  'lucide-chevron-first': ChevronFirst,
  'lucide-chevron-last': ChevronLast,
  'lucide-chevron-left': ChevronLeft,
  'lucide-chevron-right': ChevronRight,
  'lucide-chevron-up': ChevronUp,
  'lucide-chevrons-down': ChevronsDown,
  'lucide-chevrons-down-up': ChevronsDownUp,
  'lucide-chevrons-left': ChevronsLeft,
  'lucide-chevrons-left-right': ChevronsLeftRight,
  'lucide-chevrons-left-right-ellipsis': ChevronsLeftRightEllipsis,
  'lucide-chevrons-right': ChevronsRight,
  'lucide-chevrons-right-left': ChevronsRightLeft,
  'lucide-chevrons-up': ChevronsUp,
  'lucide-chevrons-up-down': ChevronsUpDown,
  'lucide-church': Church,
  'lucide-cigarette': Cigarette,
  'lucide-cigarette-off': CigaretteOff,
  'lucide-circle': Circle,
  'lucide-circle-alert': CircleAlert,
  'lucide-circle-arrow-down': CircleArrowDown,
  'lucide-circle-arrow-left': CircleArrowLeft,
  'lucide-circle-arrow-out-down-left': CircleArrowOutDownLeft,
  'lucide-circle-arrow-out-down-right': CircleArrowOutDownRight,
  'lucide-circle-arrow-out-up-left': CircleArrowOutUpLeft,
  'lucide-circle-arrow-out-up-right': CircleArrowOutUpRight,
  'lucide-circle-arrow-right': CircleArrowRight,
  'lucide-circle-arrow-up': CircleArrowUp,
  'lucide-circle-check': CircleCheck,
  'lucide-circle-check-big': CircleCheckBig,
  'lucide-circle-chevron-down': CircleChevronDown,
  'lucide-circle-chevron-left': CircleChevronLeft,
  'lucide-circle-chevron-right': CircleChevronRight,
  'lucide-circle-chevron-up': CircleChevronUp,
  'lucide-circle-dashed': CircleDashed,
  'lucide-circle-divide': CircleDivide,
  'lucide-circle-dollar-sign': CircleDollarSign,
  'lucide-circle-dot': CircleDot,
  'lucide-circle-dot-dashed': CircleDotDashed,
  'lucide-circle-ellipsis': CircleEllipsis,
  'lucide-circle-equal': CircleEqual,
  'lucide-circle-euro-sign': CircleEuroSign,
  'lucide-circle-fading-arrow-up': CircleFadingArrowUp,
  'lucide-circle-fading-plus': CircleFadingPlus,
  'lucide-circle-gauge': CircleGauge,
  'lucide-circle-minus': CircleMinus,
  'lucide-circle-off': CircleOff,
  'lucide-circle-parking': CircleParking,
  'lucide-circle-parking-off': CircleParkingOff,
  'lucide-circle-pause': CirclePause,
  'lucide-circle-percent': CirclePercent,
  'lucide-circle-pile': CirclePile,
  'lucide-circle-play': CirclePlay,
  'lucide-circle-plus': CirclePlus,
  'lucide-circle-pound-sterling': CirclePoundSterling,
  'lucide-circle-power': CirclePower,
  'lucide-circle-question-mark': CircleQuestionMark,
  'lucide-circle-slash': CircleSlash,
  'lucide-circle-slash2': CircleSlash2,
  'lucide-circle-small': CircleSmall,
  'lucide-circle-star': CircleStar,
  'lucide-circle-stop': CircleStop,
  'lucide-circle-user': CircleUser,
  'lucide-circle-user-round': CircleUserRound,
  'lucide-circle-x': CircleX,
  'lucide-circuit-board': CircuitBoard,
  'lucide-citrus': Citrus,
  'lucide-clapperboard': Clapperboard,
  'lucide-clipboard': Clipboard,
  'lucide-clipboard-check': ClipboardCheck,
  'lucide-clipboard-clock': ClipboardClock,
  'lucide-clipboard-copy': ClipboardCopy,
  'lucide-clipboard-list': ClipboardList,
  'lucide-clipboard-minus': ClipboardMinus,
  'lucide-clipboard-paste': ClipboardPaste,
  'lucide-clipboard-pen': ClipboardPen,
  'lucide-clipboard-pen-line': ClipboardPenLine,
  'lucide-clipboard-plus': ClipboardPlus,
  'lucide-clipboard-type': ClipboardType,
  'lucide-clipboard-x': ClipboardX,
  'lucide-clock': Clock,
  'lucide-clock1': Clock1,
  'lucide-clock10': Clock10,
  'lucide-clock11': Clock11,
  'lucide-clock12': Clock12,
  'lucide-clock2': Clock2,
  'lucide-clock3': Clock3,
  'lucide-clock4': Clock4,
  'lucide-clock5': Clock5,
  'lucide-clock6': Clock6,
  'lucide-clock7': Clock7,
  'lucide-clock8': Clock8,
  'lucide-clock9': Clock9,
  'lucide-clock-alert': ClockAlert,
  'lucide-clock-arrow-down': ClockArrowDown,
  'lucide-clock-arrow-left': ClockArrowLeft,
  'lucide-clock-arrow-right': ClockArrowRight,
  'lucide-clock-arrow-up': ClockArrowUp,
  'lucide-clock-check': ClockCheck,
  'lucide-clock-fading': ClockFading,
  'lucide-clock-plus': ClockPlus,
  'lucide-closed-caption': ClosedCaption,
  'lucide-cloud': Cloud,
  'lucide-cloud-alert': CloudAlert,
  'lucide-cloud-backup': CloudBackup,
  'lucide-cloud-check': CloudCheck,
  'lucide-cloud-cog': CloudCog,
  'lucide-cloud-download': CloudDownload,
  'lucide-cloud-drizzle': CloudDrizzle,
  'lucide-cloud-fog': CloudFog,
  'lucide-cloud-hail': CloudHail,
  'lucide-cloud-lightning': CloudLightning,
  'lucide-cloud-moon': CloudMoon,
  'lucide-cloud-moon-rain': CloudMoonRain,
  'lucide-cloud-off': CloudOff,
  'lucide-cloud-rain': CloudRain,
  'lucide-cloud-rain-wind': CloudRainWind,
  'lucide-cloud-snow': CloudSnow,
  'lucide-cloud-sun': CloudSun,
  'lucide-cloud-sun-rain': CloudSunRain,
  'lucide-cloud-sync': CloudSync,
  'lucide-cloud-upload': CloudUpload,
  'lucide-cloudy': Cloudy,
  'lucide-clover': Clover,
  'lucide-club': Club,
  'lucide-code': Code,
  'lucide-code-xml': CodeXml,
  'lucide-coffee': Coffee,
  'lucide-cog': Cog,
  'lucide-coins': Coins,
  'lucide-columns2': Columns2,
  'lucide-columns3': Columns3,
  'lucide-columns3-cog': Columns3Cog,
  'lucide-columns4': Columns4,
  'lucide-combine': Combine,
  'lucide-command': Command,
  'lucide-compass': Compass,
  'lucide-component': Component,
  'lucide-computer': Computer,
  'lucide-concierge-bell': ConciergeBell,
  'lucide-cone': Cone,
  'lucide-construction': Construction,
  'lucide-contact': Contact,
  'lucide-contact-round': ContactRound,
  'lucide-container': Container,
  'lucide-contrast': Contrast,
  'lucide-cookie': Cookie,
  'lucide-cooking-pot': CookingPot,
  'lucide-copy': Copy,
  'lucide-copy-check': CopyCheck,
  'lucide-copy-minus': CopyMinus,
  'lucide-copy-plus': CopyPlus,
  'lucide-copy-slash': CopySlash,
  'lucide-copy-x': CopyX,
  'lucide-copyleft': Copyleft,
  'lucide-copyright': Copyright,
  'lucide-corner-down-left': CornerDownLeft,
  'lucide-corner-down-right': CornerDownRight,
  'lucide-corner-left-down': CornerLeftDown,
  'lucide-corner-left-up': CornerLeftUp,
  'lucide-corner-right-down': CornerRightDown,
  'lucide-corner-right-up': CornerRightUp,
  'lucide-corner-up-left': CornerUpLeft,
  'lucide-corner-up-right': CornerUpRight,
  'lucide-cpu': Cpu,
  'lucide-creative-commons': CreativeCommons,
  'lucide-credit-card': CreditCard,
  'lucide-croissant': Croissant,
  'lucide-crop': Crop,
  'lucide-cross': Cross,
  'lucide-crosshair': Crosshair,
  'lucide-crown': Crown,
  'lucide-cuboid': Cuboid,
  'lucide-cup-soda': CupSoda,
  'lucide-currency': Currency,
  'lucide-cylinder': Cylinder,
  'lucide-dam': Dam,
  'lucide-database': Database,
  'lucide-database-arrow-down': DatabaseArrowDown,
  'lucide-database-arrow-up': DatabaseArrowUp,
  'lucide-database-backup': DatabaseBackup,
  'lucide-database-check': DatabaseCheck,
  'lucide-database-minus': DatabaseMinus,
  'lucide-database-plus': DatabasePlus,
  'lucide-database-search': DatabaseSearch,
  'lucide-database-x': DatabaseX,
  'lucide-database-zap': DatabaseZap,
  'lucide-decimals-arrow-left': DecimalsArrowLeft,
  'lucide-decimals-arrow-right': DecimalsArrowRight,
  'lucide-delete': Delete,
  'lucide-dessert': Dessert,
  'lucide-diameter': Diameter,
  'lucide-diamond': Diamond,
  'lucide-diamond-minus': DiamondMinus,
  'lucide-diamond-percent': DiamondPercent,
  'lucide-diamond-plus': DiamondPlus,
  'lucide-dice1': Dice1,
  'lucide-dice2': Dice2,
  'lucide-dice3': Dice3,
  'lucide-dice4': Dice4,
  'lucide-dice5': Dice5,
  'lucide-dice6': Dice6,
  'lucide-dices': Dices,
  'lucide-diff': Diff,
  'lucide-disc': Disc,
  'lucide-disc2': Disc2,
  'lucide-disc3': Disc3,
  'lucide-disc-album': DiscAlbum,
  'lucide-divide': Divide,
  'lucide-dna': Dna,
  'lucide-dna-off': DnaOff,
  'lucide-dock': Dock,
  'lucide-dog': Dog,
  'lucide-dollar-sign': DollarSign,
  'lucide-donut': Donut,
  'lucide-door-closed': DoorClosed,
  'lucide-door-closed-locked': DoorClosedLocked,
  'lucide-door-open': DoorOpen,
  'lucide-dot': Dot,
  'lucide-download': Download,
  'lucide-drafting-compass': DraftingCompass,
  'lucide-drama': Drama,
  'lucide-drill': Drill,
  'lucide-drone': Drone,
  'lucide-droplet': Droplet,
  'lucide-droplet-off': DropletOff,
  'lucide-droplets': Droplets,
  'lucide-drum': Drum,
  'lucide-drumstick': Drumstick,
  'lucide-dumbbell': Dumbbell,
  'lucide-ear': Ear,
  'lucide-ear-off': EarOff,
  'lucide-earth': Earth,
  'lucide-earth-lock': EarthLock,
  'lucide-eclipse': Eclipse,
  'lucide-egg': Egg,
  'lucide-egg-fried': EggFried,
  'lucide-egg-off': EggOff,
  'lucide-ellipse': Ellipse,
  'lucide-ellipsis': Ellipsis,
  'lucide-ellipsis-vertical': EllipsisVertical,
  'lucide-equal': Equal,
  'lucide-equal-approximately': EqualApproximately,
  'lucide-equal-not': EqualNot,
  'lucide-eraser': Eraser,
  'lucide-ethernet-port': EthernetPort,
  'lucide-euro': Euro,
  'lucide-ev-charger': EvCharger,
  'lucide-expand': Expand,
  'lucide-external-link': ExternalLink,
  'lucide-eye': Eye,
  'lucide-eye-closed': EyeClosed,
  'lucide-eye-dashed': EyeDashed,
  'lucide-eye-off': EyeOff,
  'lucide-factory': Factory,
  'lucide-fan': Fan,
  'lucide-fast-forward': FastForward,
  'lucide-feather': Feather,
  'lucide-fence': Fence,
  'lucide-ferris-wheel': FerrisWheel,
  'lucide-file': File,
  'lucide-file-archive': FileArchive,
  'lucide-file-axis3d': FileAxis3d,
  'lucide-file-badge': FileBadge,
  'lucide-file-box': FileBox,
  'lucide-file-braces': FileBraces,
  'lucide-file-braces-corner': FileBracesCorner,
  'lucide-file-chart-column': FileChartColumn,
  'lucide-file-chart-column-increasing': FileChartColumnIncreasing,
  'lucide-file-chart-line': FileChartLine,
  'lucide-file-chart-pie': FileChartPie,
  'lucide-file-check': FileCheck,
  'lucide-file-check-corner': FileCheckCorner,
  'lucide-file-clock': FileClock,
  'lucide-file-code': FileCode,
  'lucide-file-code-corner': FileCodeCorner,
  'lucide-file-cog': FileCog,
  'lucide-file-diff': FileDiff,
  'lucide-file-digit': FileDigit,
  'lucide-file-down': FileDown,
  'lucide-file-exclamation-point': FileExclamationPoint,
  'lucide-file-headphone': FileHeadphone,
  'lucide-file-heart': FileHeart,
  'lucide-file-image': FileImage,
  'lucide-file-input': FileInput,
  'lucide-file-key': FileKey,
  'lucide-file-lock': FileLock,
  'lucide-file-minus': FileMinus,
  'lucide-file-minus-corner': FileMinusCorner,
  'lucide-file-music': FileMusic,
  'lucide-file-output': FileOutput,
  'lucide-file-pen': FilePen,
  'lucide-file-pen-line': FilePenLine,
  'lucide-file-play': FilePlay,
  'lucide-file-plus': FilePlus,
  'lucide-file-plus-corner': FilePlusCorner,
  'lucide-file-question-mark': FileQuestionMark,
  'lucide-file-scan': FileScan,
  'lucide-file-search': FileSearch,
  'lucide-file-search-corner': FileSearchCorner,
  'lucide-file-signal': FileSignal,
  'lucide-file-sliders': FileSliders,
  'lucide-file-spreadsheet': FileSpreadsheet,
  'lucide-file-stack': FileStack,
  'lucide-file-symlink': FileSymlink,
  'lucide-file-terminal': FileTerminal,
  'lucide-file-text': FileText,
  'lucide-file-type': FileType,
  'lucide-file-type-corner': FileTypeCorner,
  'lucide-file-up': FileUp,
  'lucide-file-user': FileUser,
  'lucide-file-video-camera': FileVideoCamera,
  'lucide-file-volume': FileVolume,
  'lucide-file-x': FileX,
  'lucide-file-x-corner': FileXCorner,
  'lucide-files': Files,
  'lucide-film': Film,
  'lucide-fingerprint-pattern': FingerprintPattern,
  'lucide-fire-extinguisher': FireExtinguisher,
  'lucide-fish': Fish,
  'lucide-fish-off': FishOff,
  'lucide-fish-symbol': FishSymbol,
  'lucide-fishing-hook': FishingHook,
  'lucide-fishing-rod': FishingRod,
  'lucide-flag': Flag,
  'lucide-flag-off': FlagOff,
  'lucide-flag-triangle-left': FlagTriangleLeft,
  'lucide-flag-triangle-right': FlagTriangleRight,
  'lucide-flame': Flame,
  'lucide-flame-kindling': FlameKindling,
  'lucide-flashlight': Flashlight,
  'lucide-flashlight-off': FlashlightOff,
  'lucide-flask-conical': FlaskConical,
  'lucide-flask-conical-off': FlaskConicalOff,
  'lucide-flask-round': FlaskRound,
  'lucide-flip-horizontal2': FlipHorizontal2,
  'lucide-flip-vertical2': FlipVertical2,
  'lucide-flower': Flower,
  'lucide-flower2': Flower2,
  'lucide-focus': Focus,
  'lucide-fold-horizontal': FoldHorizontal,
  'lucide-fold-vertical': FoldVertical,
  'lucide-folder': Folder,
  'lucide-folder-archive': FolderArchive,
  'lucide-folder-bookmark': FolderBookmark,
  'lucide-folder-check': FolderCheck,
  'lucide-folder-clock': FolderClock,
  'lucide-folder-closed': FolderClosed,
  'lucide-folder-code': FolderCode,
  'lucide-folder-cog': FolderCog,
  'lucide-folder-dot': FolderDot,
  'lucide-folder-down': FolderDown,
  'lucide-folder-git': FolderGit,
  'lucide-folder-git2': FolderGit2,
  'lucide-folder-heart': FolderHeart,
  'lucide-folder-input': FolderInput,
  'lucide-folder-kanban': FolderKanban,
  'lucide-folder-key': FolderKey,
  'lucide-folder-lock': FolderLock,
  'lucide-folder-minus': FolderMinus,
  'lucide-folder-open': FolderOpen,
  'lucide-folder-open-dot': FolderOpenDot,
  'lucide-folder-output': FolderOutput,
  'lucide-folder-pen': FolderPen,
  'lucide-folder-plus': FolderPlus,
  'lucide-folder-root': FolderRoot,
  'lucide-folder-search': FolderSearch,
  'lucide-folder-search2': FolderSearch2,
  'lucide-folder-symlink': FolderSymlink,
  'lucide-folder-sync': FolderSync,
  'lucide-folder-tree': FolderTree,
  'lucide-folder-up': FolderUp,
  'lucide-folder-x': FolderX,
  'lucide-folders': Folders,
  'lucide-footprints': Footprints,
  'lucide-forklift': Forklift,
  'lucide-form': Form,
  'lucide-forward': Forward,
  'lucide-frame': Frame,
  'lucide-frown': Frown,
  'lucide-fuel': Fuel,
  'lucide-fullscreen': Fullscreen,
  'lucide-funnel': Funnel,
  'lucide-funnel-plus': FunnelPlus,
  'lucide-funnel-x': FunnelX,
  'lucide-gallery-horizontal': GalleryHorizontal,
  'lucide-gallery-horizontal-end': GalleryHorizontalEnd,
  'lucide-gallery-thumbnails': GalleryThumbnails,
  'lucide-gallery-vertical': GalleryVertical,
  'lucide-gallery-vertical-end': GalleryVerticalEnd,
  'lucide-gamepad': Gamepad,
  'lucide-gamepad2': Gamepad2,
  'lucide-gamepad-directional': GamepadDirectional,
  'lucide-gauge': Gauge,
  'lucide-gavel': Gavel,
  'lucide-gem': Gem,
  'lucide-georgian-lari': GeorgianLari,
  'lucide-ghost': Ghost,
  'lucide-gift': Gift,
  'lucide-git-branch': GitBranch,
  'lucide-git-branch-minus': GitBranchMinus,
  'lucide-git-branch-plus': GitBranchPlus,
  'lucide-git-commit-horizontal': GitCommitHorizontal,
  'lucide-git-commit-vertical': GitCommitVertical,
  'lucide-git-compare': GitCompare,
  'lucide-git-compare-arrows': GitCompareArrows,
  'lucide-git-fork': GitFork,
  'lucide-git-graph': GitGraph,
  'lucide-git-merge': GitMerge,
  'lucide-git-merge-conflict': GitMergeConflict,
  'lucide-git-pull-request': GitPullRequest,
  'lucide-git-pull-request-arrow': GitPullRequestArrow,
  'lucide-git-pull-request-closed': GitPullRequestClosed,
  'lucide-git-pull-request-create': GitPullRequestCreate,
  'lucide-git-pull-request-create-arrow': GitPullRequestCreateArrow,
  'lucide-git-pull-request-draft': GitPullRequestDraft,
  'lucide-glass-water': GlassWater,
  'lucide-glasses': Glasses,
  'lucide-globe': Globe,
  'lucide-globe-check': GlobeCheck,
  'lucide-globe-lock': GlobeLock,
  'lucide-globe-off': GlobeOff,
  'lucide-globe-x': GlobeX,
  'lucide-goal': Goal,
  'lucide-gpu': Gpu,
  'lucide-graduation-cap': GraduationCap,
  'lucide-grape': Grape,
  'lucide-grid2x2': Grid2x2,
  'lucide-grid2x2-check': Grid2x2Check,
  'lucide-grid2x2-plus': Grid2x2Plus,
  'lucide-grid2x2-x': Grid2x2X,
  'lucide-grid3x2': Grid3x2,
  'lucide-grid3x3': Grid3x3,
  'lucide-grip': Grip,
  'lucide-grip-horizontal': GripHorizontal,
  'lucide-grip-vertical': GripVertical,
  'lucide-group': Group,
  'lucide-guitar': Guitar,
  'lucide-ham': Ham,
  'lucide-hamburger': Hamburger,
  'lucide-hammer': Hammer,
  'lucide-hand': Hand,
  'lucide-hand-coins': HandCoins,
  'lucide-hand-fist': HandFist,
  'lucide-hand-grab': HandGrab,
  'lucide-hand-heart': HandHeart,
  'lucide-hand-helping': HandHelping,
  'lucide-hand-metal': HandMetal,
  'lucide-hand-platter': HandPlatter,
  'lucide-handbag': Handbag,
  'lucide-handshake': Handshake,
  'lucide-hard-drive': HardDrive,
  'lucide-hard-drive-download': HardDriveDownload,
  'lucide-hard-drive-upload': HardDriveUpload,
  'lucide-hard-hat': HardHat,
  'lucide-hash': Hash,
  'lucide-hat-glasses': HatGlasses,
  'lucide-haze': Haze,
  'lucide-hd': Hd,
  'lucide-hdmi-port': HdmiPort,
  'lucide-heading': Heading,
  'lucide-heading1': Heading1,
  'lucide-heading2': Heading2,
  'lucide-heading3': Heading3,
  'lucide-heading4': Heading4,
  'lucide-heading5': Heading5,
  'lucide-heading6': Heading6,
  'lucide-headphone-off': HeadphoneOff,
  'lucide-headphones': Headphones,
  'lucide-headset': Headset,
  'lucide-heart': Heart,
  'lucide-heart-crack': HeartCrack,
  'lucide-heart-handshake': HeartHandshake,
  'lucide-heart-minus': HeartMinus,
  'lucide-heart-off': HeartOff,
  'lucide-heart-plus': HeartPlus,
  'lucide-heart-pulse': HeartPulse,
  'lucide-heart-x': HeartX,
  'lucide-heater': Heater,
  'lucide-helicopter': Helicopter,
  'lucide-hexagon': Hexagon,
  'lucide-highlighter': Highlighter,
  'lucide-history': History,
  'lucide-hop': Hop,
  'lucide-hop-off': HopOff,
  'lucide-hospital': Hospital,
  'lucide-hotel': Hotel,
  'lucide-hourglass': Hourglass,
  'lucide-house': House,
  'lucide-house-heart': HouseHeart,
  'lucide-house-plug': HousePlug,
  'lucide-house-plus': HousePlus,
  'lucide-house-wifi': HouseWifi,
  'lucide-ice-cream-bowl': IceCreamBowl,
  'lucide-ice-cream-cone': IceCreamCone,
  'lucide-id-card': IdCard,
  'lucide-id-card-lanyard': IdCardLanyard,
  'lucide-image': Image,
  'lucide-image-down': ImageDown,
  'lucide-image-minus': ImageMinus,
  'lucide-image-off': ImageOff,
  'lucide-image-play': ImagePlay,
  'lucide-image-plus': ImagePlus,
  'lucide-image-up': ImageUp,
  'lucide-image-upscale': ImageUpscale,
  'lucide-images': Images,
  'lucide-import': Import,
  'lucide-inbox': Inbox,
  'lucide-indian-rupee': IndianRupee,
  'lucide-infinity': Infinity,
  'lucide-info': Info,
  'lucide-inspection-panel': InspectionPanel,
  'lucide-italic': Italic,
  'lucide-iteration-ccw': IterationCcw,
  'lucide-iteration-cw': IterationCw,
  'lucide-japanese-yen': JapaneseYen,
  'lucide-joystick': Joystick,
  'lucide-kanban': Kanban,
  'lucide-kayak': Kayak,
  'lucide-key': Key,
  'lucide-key-round': KeyRound,
  'lucide-key-square': KeySquare,
  'lucide-keyboard': Keyboard,
  'lucide-keyboard-music': KeyboardMusic,
  'lucide-keyboard-off': KeyboardOff,
  'lucide-lamp': Lamp,
  'lucide-lamp-ceiling': LampCeiling,
  'lucide-lamp-desk': LampDesk,
  'lucide-lamp-floor': LampFloor,
  'lucide-lamp-wall-down': LampWallDown,
  'lucide-lamp-wall-up': LampWallUp,
  'lucide-land-plot': LandPlot,
  'lucide-landmark': Landmark,
  'lucide-languages': Languages,
  'lucide-laptop': Laptop,
  'lucide-laptop-minimal': LaptopMinimal,
  'lucide-laptop-minimal-check': LaptopMinimalCheck,
  'lucide-lasso': Lasso,
  'lucide-lasso-select': LassoSelect,
  'lucide-laugh': Laugh,
  'lucide-layers': Layers,
  'lucide-layers2': Layers2,
  'lucide-layers-minus': LayersMinus,
  'lucide-layers-plus': LayersPlus,
  'lucide-layout-dashboard': LayoutDashboard,
  'lucide-layout-grid': LayoutGrid,
  'lucide-layout-list': LayoutList,
  'lucide-layout-panel-left': LayoutPanelLeft,
  'lucide-layout-panel-top': LayoutPanelTop,
  'lucide-layout-template': LayoutTemplate,
  'lucide-leaf': Leaf,
  'lucide-leafy-green': LeafyGreen,
  'lucide-lectern': Lectern,
  'lucide-lens-concave': LensConcave,
  'lucide-lens-convex': LensConvex,
  'lucide-library': Library,
  'lucide-library-big': LibraryBig,
  'lucide-life-buoy': LifeBuoy,
  'lucide-ligature': Ligature,
  'lucide-lightbulb': Lightbulb,
  'lucide-lightbulb-off': LightbulbOff,
  'lucide-line-dot-right-horizontal': LineDotRightHorizontal,
  'lucide-line-squiggle': LineSquiggle,
  'lucide-line-style': LineStyle,
  'lucide-link': Link,
  'lucide-link2': Link2,
  'lucide-link2-off': Link2Off,
  'lucide-list': List,
  'lucide-list-check': ListCheck,
  'lucide-list-checks': ListChecks,
  'lucide-list-chevrons-down-up': ListChevronsDownUp,
  'lucide-list-chevrons-up-down': ListChevronsUpDown,
  'lucide-list-collapse': ListCollapse,
  'lucide-list-end': ListEnd,
  'lucide-list-filter': ListFilter,
  'lucide-list-filter-plus': ListFilterPlus,
  'lucide-list-indent-decrease': ListIndentDecrease,
  'lucide-list-indent-increase': ListIndentIncrease,
  'lucide-list-minus': ListMinus,
  'lucide-list-music': ListMusic,
  'lucide-list-ordered': ListOrdered,
  'lucide-list-plus': ListPlus,
  'lucide-list-restart': ListRestart,
  'lucide-list-sort-ascending': ListSortAscending,
  'lucide-list-sort-descending': ListSortDescending,
  'lucide-list-start': ListStart,
  'lucide-list-todo': ListTodo,
  'lucide-list-tree': ListTree,
  'lucide-list-video': ListVideo,
  'lucide-list-x': ListX,
  'lucide-loader': Loader,
  'lucide-loader-circle': LoaderCircle,
  'lucide-loader-pinwheel': LoaderPinwheel,
  'lucide-locate': Locate,
  'lucide-locate-fixed': LocateFixed,
  'lucide-locate-off': LocateOff,
  'lucide-lock': Lock,
  'lucide-lock-keyhole': LockKeyhole,
  'lucide-lock-keyhole-open': LockKeyholeOpen,
  'lucide-lock-open': LockOpen,
  'lucide-log-in': LogIn,
  'lucide-log-out': LogOut,
  'lucide-logs': Logs,
  'lucide-lollipop': Lollipop,
  'lucide-luggage': Luggage,
  'lucide-magnet': Magnet,
  'lucide-mail': Mail,
  'lucide-mail-check': MailCheck,
  'lucide-mail-minus': MailMinus,
  'lucide-mail-open': MailOpen,
  'lucide-mail-plus': MailPlus,
  'lucide-mail-question-mark': MailQuestionMark,
  'lucide-mail-search': MailSearch,
  'lucide-mail-warning': MailWarning,
  'lucide-mail-x': MailX,
  'lucide-mailbox': Mailbox,
  'lucide-mails': Mails,
  'lucide-map': Map,
  'lucide-map-minus': MapMinus,
  'lucide-map-pin': MapPin,
  'lucide-map-pin-check': MapPinCheck,
  'lucide-map-pin-check-inside': MapPinCheckInside,
  'lucide-map-pin-house': MapPinHouse,
  'lucide-map-pin-minus': MapPinMinus,
  'lucide-map-pin-minus-inside': MapPinMinusInside,
  'lucide-map-pin-off': MapPinOff,
  'lucide-map-pin-pen': MapPinPen,
  'lucide-map-pin-plus': MapPinPlus,
  'lucide-map-pin-plus-inside': MapPinPlusInside,
  'lucide-map-pin-search': MapPinSearch,
  'lucide-map-pin-x': MapPinX,
  'lucide-map-pin-x-inside': MapPinXInside,
  'lucide-map-pinned': MapPinned,
  'lucide-map-plus': MapPlus,
  'lucide-mars': Mars,
  'lucide-mars-stroke': MarsStroke,
  'lucide-martini': Martini,
  'lucide-maximize': Maximize,
  'lucide-maximize2': Maximize2,
  'lucide-medal': Medal,
  'lucide-megaphone': Megaphone,
  'lucide-megaphone-off': MegaphoneOff,
  'lucide-meh': Meh,
  'lucide-memory-stick': MemoryStick,
  'lucide-menu': Menu,
  'lucide-merge': Merge,
  'lucide-message-circle': MessageCircle,
  'lucide-message-circle-check': MessageCircleCheck,
  'lucide-message-circle-code': MessageCircleCode,
  'lucide-message-circle-dashed': MessageCircleDashed,
  'lucide-message-circle-heart': MessageCircleHeart,
  'lucide-message-circle-more': MessageCircleMore,
  'lucide-message-circle-off': MessageCircleOff,
  'lucide-message-circle-plus': MessageCirclePlus,
  'lucide-message-circle-question-mark': MessageCircleQuestionMark,
  'lucide-message-circle-reply': MessageCircleReply,
  'lucide-message-circle-warning': MessageCircleWarning,
  'lucide-message-circle-x': MessageCircleX,
  'lucide-message-square': MessageSquare,
  'lucide-message-square-check': MessageSquareCheck,
  'lucide-message-square-code': MessageSquareCode,
  'lucide-message-square-dashed': MessageSquareDashed,
  'lucide-message-square-diff': MessageSquareDiff,
  'lucide-message-square-dot': MessageSquareDot,
  'lucide-message-square-heart': MessageSquareHeart,
  'lucide-message-square-lock': MessageSquareLock,
  'lucide-message-square-more': MessageSquareMore,
  'lucide-message-square-off': MessageSquareOff,
  'lucide-message-square-plus': MessageSquarePlus,
  'lucide-message-square-quote': MessageSquareQuote,
  'lucide-message-square-reply': MessageSquareReply,
  'lucide-message-square-share': MessageSquareShare,
  'lucide-message-square-text': MessageSquareText,
  'lucide-message-square-warning': MessageSquareWarning,
  'lucide-message-square-x': MessageSquareX,
  'lucide-messages-square': MessagesSquare,
  'lucide-metronome': Metronome,
  'lucide-mic': Mic,
  'lucide-mic-off': MicOff,
  'lucide-mic-vocal': MicVocal,
  'lucide-microchip': Microchip,
  'lucide-microscope': Microscope,
  'lucide-microwave': Microwave,
  'lucide-milestone': Milestone,
  'lucide-milk': Milk,
  'lucide-milk-off': MilkOff,
  'lucide-minimize': Minimize,
  'lucide-minimize2': Minimize2,
  'lucide-minus': Minus,
  'lucide-mirror-rectangular': MirrorRectangular,
  'lucide-mirror-round': MirrorRound,
  'lucide-monitor': Monitor,
  'lucide-monitor-check': MonitorCheck,
  'lucide-monitor-cloud': MonitorCloud,
  'lucide-monitor-cog': MonitorCog,
  'lucide-monitor-dot': MonitorDot,
  'lucide-monitor-down': MonitorDown,
  'lucide-monitor-off': MonitorOff,
  'lucide-monitor-pause': MonitorPause,
  'lucide-monitor-play': MonitorPlay,
  'lucide-monitor-smartphone': MonitorSmartphone,
  'lucide-monitor-speaker': MonitorSpeaker,
  'lucide-monitor-stop': MonitorStop,
  'lucide-monitor-up': MonitorUp,
  'lucide-monitor-x': MonitorX,
  'lucide-moon': Moon,
  'lucide-moon-star': MoonStar,
  'lucide-motorbike': Motorbike,
  'lucide-mountain': Mountain,
  'lucide-mountain-snow': MountainSnow,
  'lucide-mouse': Mouse,
  'lucide-mouse-left': MouseLeft,
  'lucide-mouse-off': MouseOff,
  'lucide-mouse-pointer': MousePointer,
  'lucide-mouse-pointer2': MousePointer2,
  'lucide-mouse-pointer2-off': MousePointer2Off,
  'lucide-mouse-pointer-ban': MousePointerBan,
  'lucide-mouse-pointer-click': MousePointerClick,
  'lucide-mouse-right': MouseRight,
  'lucide-move': Move,
  'lucide-move3d': Move3d,
  'lucide-move-diagonal': MoveDiagonal,
  'lucide-move-diagonal2': MoveDiagonal2,
  'lucide-move-down': MoveDown,
  'lucide-move-down-left': MoveDownLeft,
  'lucide-move-down-right': MoveDownRight,
  'lucide-move-horizontal': MoveHorizontal,
  'lucide-move-left': MoveLeft,
  'lucide-move-right': MoveRight,
  'lucide-move-up': MoveUp,
  'lucide-move-up-left': MoveUpLeft,
  'lucide-move-up-right': MoveUpRight,
  'lucide-move-vertical': MoveVertical,
  'lucide-music': Music,
  'lucide-music2': Music2,
  'lucide-music3': Music3,
  'lucide-music4': Music4,
  'lucide-navigation': Navigation,
  'lucide-navigation2': Navigation2,
  'lucide-navigation2-off': Navigation2Off,
  'lucide-navigation-off': NavigationOff,
  'lucide-network': Network,
  'lucide-newspaper': Newspaper,
  'lucide-nfc': Nfc,
  'lucide-non-binary': NonBinary,
  'lucide-notebook': Notebook,
  'lucide-notebook-pen': NotebookPen,
  'lucide-notebook-tabs': NotebookTabs,
  'lucide-notebook-text': NotebookText,
  'lucide-notepad-text': NotepadText,
  'lucide-notepad-text-dashed': NotepadTextDashed,
  'lucide-nut': Nut,
  'lucide-nut-off': NutOff,
  'lucide-octagon': Octagon,
  'lucide-octagon-alert': OctagonAlert,
  'lucide-octagon-minus': OctagonMinus,
  'lucide-octagon-pause': OctagonPause,
  'lucide-octagon-x': OctagonX,
  'lucide-omega': Omega,
  'lucide-option': Option,
  'lucide-orbit': Orbit,
  'lucide-origami': Origami,
  'lucide-package': Package,
  'lucide-package2': Package2,
  'lucide-package-check': PackageCheck,
  'lucide-package-minus': PackageMinus,
  'lucide-package-open': PackageOpen,
  'lucide-package-plus': PackagePlus,
  'lucide-package-search': PackageSearch,
  'lucide-package-x': PackageX,
  'lucide-paint-bucket': PaintBucket,
  'lucide-paint-roller': PaintRoller,
  'lucide-paintbrush': Paintbrush,
  'lucide-paintbrush-vertical': PaintbrushVertical,
  'lucide-palette': Palette,
  'lucide-panda': Panda,
  'lucide-panel-bottom': PanelBottom,
  'lucide-panel-bottom-close': PanelBottomClose,
  'lucide-panel-bottom-dashed': PanelBottomDashed,
  'lucide-panel-bottom-open': PanelBottomOpen,
  'lucide-panel-left': PanelLeft,
  'lucide-panel-left-close': PanelLeftClose,
  'lucide-panel-left-dashed': PanelLeftDashed,
  'lucide-panel-left-open': PanelLeftOpen,
  'lucide-panel-left-right-dashed': PanelLeftRightDashed,
  'lucide-panel-right': PanelRight,
  'lucide-panel-right-close': PanelRightClose,
  'lucide-panel-right-dashed': PanelRightDashed,
  'lucide-panel-right-open': PanelRightOpen,
  'lucide-panel-top': PanelTop,
  'lucide-panel-top-bottom-dashed': PanelTopBottomDashed,
  'lucide-panel-top-close': PanelTopClose,
  'lucide-panel-top-dashed': PanelTopDashed,
  'lucide-panel-top-open': PanelTopOpen,
  'lucide-panels-left-bottom': PanelsLeftBottom,
  'lucide-panels-right-bottom': PanelsRightBottom,
  'lucide-panels-top-left': PanelsTopLeft,
  'lucide-paper-bag': PaperBag,
  'lucide-paperclip': Paperclip,
  'lucide-parasol': Parasol,
  'lucide-parentheses': Parentheses,
  'lucide-parking-meter': ParkingMeter,
  'lucide-party-popper': PartyPopper,
  'lucide-pause': Pause,
  'lucide-paw-print': PawPrint,
  'lucide-pc-case': PcCase,
  'lucide-pen': Pen,
  'lucide-pen-line': PenLine,
  'lucide-pen-off': PenOff,
  'lucide-pen-tool': PenTool,
  'lucide-pencil': Pencil,
  'lucide-pencil-line': PencilLine,
  'lucide-pencil-off': PencilOff,
  'lucide-pencil-ruler': PencilRuler,
  'lucide-pencil-sparkles': PencilSparkles,
  'lucide-pentagon': Pentagon,
  'lucide-percent': Percent,
  'lucide-person-standing': PersonStanding,
  'lucide-phi': Phi,
  'lucide-philippine-peso': PhilippinePeso,
  'lucide-phone': Phone,
  'lucide-phone-call': PhoneCall,
  'lucide-phone-forwarded': PhoneForwarded,
  'lucide-phone-incoming': PhoneIncoming,
  'lucide-phone-missed': PhoneMissed,
  'lucide-phone-off': PhoneOff,
  'lucide-phone-outgoing': PhoneOutgoing,
  'lucide-pi': Pi,
  'lucide-piano': Piano,
  'lucide-pickaxe': Pickaxe,
  'lucide-picture-in-picture': PictureInPicture,
  'lucide-picture-in-picture2': PictureInPicture2,
  'lucide-piggy-bank': PiggyBank,
  'lucide-pilcrow': Pilcrow,
  'lucide-pilcrow-left': PilcrowLeft,
  'lucide-pilcrow-right': PilcrowRight,
  'lucide-pill': Pill,
  'lucide-pill-bottle': PillBottle,
  'lucide-pin': Pin,
  'lucide-pin-off': PinOff,
  'lucide-pipette': Pipette,
  'lucide-pizza': Pizza,
  'lucide-plane': Plane,
  'lucide-plane-landing': PlaneLanding,
  'lucide-plane-takeoff': PlaneTakeoff,
  'lucide-play': Play,
  'lucide-play-off': PlayOff,
  'lucide-plug': Plug,
  'lucide-plug2': Plug2,
  'lucide-plug-zap': PlugZap,
  'lucide-plus': Plus,
  'lucide-pocket-knife': PocketKnife,
  'lucide-podcast': Podcast,
  'lucide-podium': Podium,
  'lucide-pointer': Pointer,
  'lucide-pointer-off': PointerOff,
  'lucide-popcorn': Popcorn,
  'lucide-popsicle': Popsicle,
  'lucide-pound-sterling': PoundSterling,
  'lucide-power': Power,
  'lucide-power-off': PowerOff,
  'lucide-presentation': Presentation,
  'lucide-printer': Printer,
  'lucide-printer-check': PrinterCheck,
  'lucide-printer-x': PrinterX,
  'lucide-projector': Projector,
  'lucide-proportions': Proportions,
  'lucide-puzzle': Puzzle,
  'lucide-pyramid': Pyramid,
  'lucide-qr-code': QrCode,
  'lucide-quote': Quote,
  'lucide-rabbit': Rabbit,
  'lucide-radar': Radar,
  'lucide-radiation': Radiation,
  'lucide-radical': Radical,
  'lucide-radio': Radio,
  'lucide-radio-off': RadioOff,
  'lucide-radio-receiver': RadioReceiver,
  'lucide-radio-tower': RadioTower,
  'lucide-radius': Radius,
  'lucide-rainbow': Rainbow,
  'lucide-rat': Rat,
  'lucide-ratio': Ratio,
  'lucide-receipt': Receipt,
  'lucide-receipt-cent': ReceiptCent,
  'lucide-receipt-euro': ReceiptEuro,
  'lucide-receipt-indian-rupee': ReceiptIndianRupee,
  'lucide-receipt-japanese-yen': ReceiptJapaneseYen,
  'lucide-receipt-pound-sterling': ReceiptPoundSterling,
  'lucide-receipt-russian-ruble': ReceiptRussianRuble,
  'lucide-receipt-swiss-franc': ReceiptSwissFranc,
  'lucide-receipt-text': ReceiptText,
  'lucide-receipt-turkish-lira': ReceiptTurkishLira,
  'lucide-rectangle-circle': RectangleCircle,
  'lucide-rectangle-ellipsis': RectangleEllipsis,
  'lucide-rectangle-goggles': RectangleGoggles,
  'lucide-rectangle-horizontal': RectangleHorizontal,
  'lucide-rectangle-vertical': RectangleVertical,
  'lucide-recycle': Recycle,
  'lucide-redo': Redo,
  'lucide-redo2': Redo2,
  'lucide-redo-dot': RedoDot,
  'lucide-refresh-ccw': RefreshCcw,
  'lucide-refresh-ccw-dot': RefreshCcwDot,
  'lucide-refresh-cw': RefreshCw,
  'lucide-refresh-cw-off': RefreshCwOff,
  'lucide-refrigerator': Refrigerator,
  'lucide-regex': Regex,
  'lucide-remove-formatting': RemoveFormatting,
  'lucide-repeat': Repeat,
  'lucide-repeat1': Repeat1,
  'lucide-repeat2': Repeat2,
  'lucide-repeat-off': RepeatOff,
  'lucide-replace': Replace,
  'lucide-replace-all': ReplaceAll,
  'lucide-reply': Reply,
  'lucide-reply-all': ReplyAll,
  'lucide-rewind': Rewind,
  'lucide-ribbon': Ribbon,
  'lucide-road': Road,
  'lucide-rocket': Rocket,
  'lucide-rocking-chair': RockingChair,
  'lucide-roller-coaster': RollerCoaster,
  'lucide-rose': Rose,
  'lucide-rotate3d': Rotate3d,
  'lucide-rotate-ccw': RotateCcw,
  'lucide-rotate-ccw-key': RotateCcwKey,
  'lucide-rotate-ccw-square': RotateCcwSquare,
  'lucide-rotate-cw': RotateCw,
  'lucide-rotate-cw-square': RotateCwSquare,
  'lucide-route': Route,
  'lucide-route-off': RouteOff,
  'lucide-router': Router,
  'lucide-rows2': Rows2,
  'lucide-rows3': Rows3,
  'lucide-rows4': Rows4,
  'lucide-rss': Rss,
  'lucide-ruler': Ruler,
  'lucide-ruler-dimension-line': RulerDimensionLine,
  'lucide-russian-ruble': RussianRuble,
  'lucide-sailboat': Sailboat,
  'lucide-salad': Salad,
  'lucide-sandwich': Sandwich,
  'lucide-satellite': Satellite,
  'lucide-satellite-dish': SatelliteDish,
  'lucide-saudi-riyal': SaudiRiyal,
  'lucide-save': Save,
  'lucide-save-all': SaveAll,
  'lucide-save-check': SaveCheck,
  'lucide-save-off': SaveOff,
  'lucide-save-pen': SavePen,
  'lucide-save-plus': SavePlus,
  'lucide-scale': Scale,
  'lucide-scale3d': Scale3d,
  'lucide-scaling': Scaling,
  'lucide-scan': Scan,
  'lucide-scan-barcode': ScanBarcode,
  'lucide-scan-eye': ScanEye,
  'lucide-scan-face': ScanFace,
  'lucide-scan-heart': ScanHeart,
  'lucide-scan-line': ScanLine,
  'lucide-scan-qr-code': ScanQrCode,
  'lucide-scan-search': ScanSearch,
  'lucide-scan-text': ScanText,
  'lucide-school': School,
  'lucide-scissors': Scissors,
  'lucide-scissors-line-dashed': ScissorsLineDashed,
  'lucide-scooter': Scooter,
  'lucide-screen-share': ScreenShare,
  'lucide-screen-share-off': ScreenShareOff,
  'lucide-scroll': Scroll,
  'lucide-scroll-text': ScrollText,
  'lucide-search': Search,
  'lucide-search-alert': SearchAlert,
  'lucide-search-check': SearchCheck,
  'lucide-search-code': SearchCode,
  'lucide-search-slash': SearchSlash,
  'lucide-search-x': SearchX,
  'lucide-section': Section,
  'lucide-send': Send,
  'lucide-send-horizontal': SendHorizontal,
  'lucide-send-to-back': SendToBack,
  'lucide-separator-horizontal': SeparatorHorizontal,
  'lucide-separator-vertical': SeparatorVertical,
  'lucide-server': Server,
  'lucide-server-cog': ServerCog,
  'lucide-server-crash': ServerCrash,
  'lucide-server-off': ServerOff,
  'lucide-settings': Settings,
  'lucide-settings2': Settings2,
  'lucide-shapes': Shapes,
  'lucide-share': Share,
  'lucide-share2': Share2,
  'lucide-sheet': Sheet,
  'lucide-shell': Shell,
  'lucide-shelving-unit': ShelvingUnit,
  'lucide-shield': Shield,
  'lucide-shield-alert': ShieldAlert,
  'lucide-shield-ban': ShieldBan,
  'lucide-shield-check': ShieldCheck,
  'lucide-shield-cog': ShieldCog,
  'lucide-shield-cog-corner': ShieldCogCorner,
  'lucide-shield-ellipsis': ShieldEllipsis,
  'lucide-shield-half': ShieldHalf,
  'lucide-shield-minus': ShieldMinus,
  'lucide-shield-off': ShieldOff,
  'lucide-shield-plus': ShieldPlus,
  'lucide-shield-question-mark': ShieldQuestionMark,
  'lucide-shield-user': ShieldUser,
  'lucide-shield-x': ShieldX,
  'lucide-ship': Ship,
  'lucide-ship-wheel': ShipWheel,
  'lucide-shirt': Shirt,
  'lucide-shopping-bag': ShoppingBag,
  'lucide-shopping-basket': ShoppingBasket,
  'lucide-shopping-cart': ShoppingCart,
  'lucide-shovel': Shovel,
  'lucide-shower-head': ShowerHead,
  'lucide-shredder': Shredder,
  'lucide-shrimp': Shrimp,
  'lucide-shrink': Shrink,
  'lucide-shrub': Shrub,
  'lucide-shuffle': Shuffle,
  'lucide-sigma': Sigma,
  'lucide-signal': Signal,
  'lucide-signal-high': SignalHigh,
  'lucide-signal-low': SignalLow,
  'lucide-signal-medium': SignalMedium,
  'lucide-signal-zero': SignalZero,
  'lucide-signature': Signature,
  'lucide-signpost': Signpost,
  'lucide-signpost-big': SignpostBig,
  'lucide-siren': Siren,
  'lucide-skip-back': SkipBack,
  'lucide-skip-forward': SkipForward,
  'lucide-skull': Skull,
  'lucide-slash': Slash,
  'lucide-slice': Slice,
  'lucide-sliders-horizontal': SlidersHorizontal,
  'lucide-sliders-vertical': SlidersVertical,
  'lucide-smartphone': Smartphone,
  'lucide-smartphone-charging': SmartphoneCharging,
  'lucide-smartphone-nfc': SmartphoneNfc,
  'lucide-smile': Smile,
  'lucide-smile-plus': SmilePlus,
  'lucide-snail': Snail,
  'lucide-snowflake': Snowflake,
  'lucide-soap-dispenser-droplet': SoapDispenserDroplet,
  'lucide-sofa': Sofa,
  'lucide-solar-panel': SolarPanel,
  'lucide-soup': Soup,
  'lucide-space': Space,
  'lucide-spade': Spade,
  'lucide-sparkle': Sparkle,
  'lucide-sparkles': Sparkles,
  'lucide-speaker': Speaker,
  'lucide-speech': Speech,
  'lucide-spell-check': SpellCheck,
  'lucide-spell-check2': SpellCheck2,
  'lucide-spline': Spline,
  'lucide-spline-pointer': SplinePointer,
  'lucide-split': Split,
  'lucide-spool': Spool,
  'lucide-sport-shoe': SportShoe,
  'lucide-spotlight': Spotlight,
  'lucide-spray-can': SprayCan,
  'lucide-sprout': Sprout,
  'lucide-square': Square,
  'lucide-square-activity': SquareActivity,
  'lucide-square-arrow-down': SquareArrowDown,
  'lucide-square-arrow-down-left': SquareArrowDownLeft,
  'lucide-square-arrow-down-right': SquareArrowDownRight,
  'lucide-square-arrow-left': SquareArrowLeft,
  'lucide-square-arrow-out-down-left': SquareArrowOutDownLeft,
  'lucide-square-arrow-out-down-right': SquareArrowOutDownRight,
  'lucide-square-arrow-out-up-left': SquareArrowOutUpLeft,
  'lucide-square-arrow-out-up-right': SquareArrowOutUpRight,
  'lucide-square-arrow-right': SquareArrowRight,
  'lucide-square-arrow-right-enter': SquareArrowRightEnter,
  'lucide-square-arrow-right-exit': SquareArrowRightExit,
  'lucide-square-arrow-up': SquareArrowUp,
  'lucide-square-arrow-up-left': SquareArrowUpLeft,
  'lucide-square-arrow-up-right': SquareArrowUpRight,
  'lucide-square-asterisk': SquareAsterisk,
  'lucide-square-bottom-dashed-scissors': SquareBottomDashedScissors,
  'lucide-square-centerline-dashed-horizontal': SquareCenterlineDashedHorizontal,
  'lucide-square-centerline-dashed-vertical': SquareCenterlineDashedVertical,
  'lucide-square-chart-gantt': SquareChartGantt,
  'lucide-square-check': SquareCheck,
  'lucide-square-check-big': SquareCheckBig,
  'lucide-square-chevron-down': SquareChevronDown,
  'lucide-square-chevron-left': SquareChevronLeft,
  'lucide-square-chevron-right': SquareChevronRight,
  'lucide-square-chevron-up': SquareChevronUp,
  'lucide-square-code': SquareCode,
  'lucide-square-dashed': SquareDashed,
  'lucide-square-dashed-bottom': SquareDashedBottom,
  'lucide-square-dashed-bottom-code': SquareDashedBottomCode,
  'lucide-square-dashed-kanban': SquareDashedKanban,
  'lucide-square-dashed-mouse-pointer': SquareDashedMousePointer,
  'lucide-square-dashed-text': SquareDashedText,
  'lucide-square-dashed-top-solid': SquareDashedTopSolid,
  'lucide-square-divide': SquareDivide,
  'lucide-square-dot': SquareDot,
  'lucide-square-equal': SquareEqual,
  'lucide-square-function': SquareFunction,
  'lucide-square-kanban': SquareKanban,
  'lucide-square-library': SquareLibrary,
  'lucide-square-m': SquareM,
  'lucide-square-menu': SquareMenu,
  'lucide-square-minus': SquareMinus,
  'lucide-square-mouse-pointer': SquareMousePointer,
  'lucide-square-parking': SquareParking,
  'lucide-square-parking-off': SquareParkingOff,
  'lucide-square-pause': SquarePause,
  'lucide-square-pen': SquarePen,
  'lucide-square-percent': SquarePercent,
  'lucide-square-pi': SquarePi,
  'lucide-square-pilcrow': SquarePilcrow,
  'lucide-square-play': SquarePlay,
  'lucide-square-plus': SquarePlus,
  'lucide-square-power': SquarePower,
  'lucide-square-radical': SquareRadical,
  'lucide-square-round-corner': SquareRoundCorner,
  'lucide-square-scissors': SquareScissors,
  'lucide-square-sigma': SquareSigma,
  'lucide-square-slash': SquareSlash,
  'lucide-square-split-horizontal': SquareSplitHorizontal,
  'lucide-square-split-vertical': SquareSplitVertical,
  'lucide-square-square': SquareSquare,
  'lucide-square-stack': SquareStack,
  'lucide-square-star': SquareStar,
  'lucide-square-stop': SquareStop,
  'lucide-square-terminal': SquareTerminal,
  'lucide-square-user': SquareUser,
  'lucide-square-user-round': SquareUserRound,
  'lucide-square-x': SquareX,
  'lucide-squares-exclude': SquaresExclude,
  'lucide-squares-intersect': SquaresIntersect,
  'lucide-squares-subtract': SquaresSubtract,
  'lucide-squares-unite': SquaresUnite,
  'lucide-squircle': Squircle,
  'lucide-squircle-dashed': SquircleDashed,
  'lucide-squirrel': Squirrel,
  'lucide-stamp': Stamp,
  'lucide-star': Star,
  'lucide-star-check': StarCheck,
  'lucide-star-half': StarHalf,
  'lucide-star-minus': StarMinus,
  'lucide-star-off': StarOff,
  'lucide-star-plus': StarPlus,
  'lucide-star-x': StarX,
  'lucide-step-back': StepBack,
  'lucide-step-forward': StepForward,
  'lucide-stethoscope': Stethoscope,
  'lucide-sticker': Sticker,
  'lucide-sticky-note': StickyNote,
  'lucide-sticky-note-check': StickyNoteCheck,
  'lucide-sticky-note-minus': StickyNoteMinus,
  'lucide-sticky-note-off': StickyNoteOff,
  'lucide-sticky-note-plus': StickyNotePlus,
  'lucide-sticky-note-x': StickyNoteX,
  'lucide-sticky-notes': StickyNotes,
  'lucide-stone': Stone,
  'lucide-store': Store,
  'lucide-stretch-horizontal': StretchHorizontal,
  'lucide-stretch-vertical': StretchVertical,
  'lucide-strikethrough': Strikethrough,
  'lucide-subscript': Subscript,
  'lucide-summary': Summary,
  'lucide-sun': Sun,
  'lucide-sun-dim': SunDim,
  'lucide-sun-medium': SunMedium,
  'lucide-sun-moon': SunMoon,
  'lucide-sun-snow': SunSnow,
  'lucide-sunrise': Sunrise,
  'lucide-sunset': Sunset,
  'lucide-superscript': Superscript,
  'lucide-swatch-book': SwatchBook,
  'lucide-swiss-franc': SwissFranc,
  'lucide-switch-camera': SwitchCamera,
  'lucide-sword': Sword,
  'lucide-swords': Swords,
  'lucide-syringe': Syringe,
  'lucide-table': Table,
  'lucide-table2': Table2,
  'lucide-table-cells-merge': TableCellsMerge,
  'lucide-table-cells-split': TableCellsSplit,
  'lucide-table-columns-split': TableColumnsSplit,
  'lucide-table-of-contents': TableOfContents,
  'lucide-table-properties': TableProperties,
  'lucide-table-rows-split': TableRowsSplit,
  'lucide-tablet': Tablet,
  'lucide-tablet-smartphone': TabletSmartphone,
  'lucide-tablets': Tablets,
  'lucide-tag': Tag,
  'lucide-tag-plus': TagPlus,
  'lucide-tag-x': TagX,
  'lucide-tags': Tags,
  'lucide-tally1': Tally1,
  'lucide-tally2': Tally2,
  'lucide-tally3': Tally3,
  'lucide-tally4': Tally4,
  'lucide-tally5': Tally5,
  'lucide-tangent': Tangent,
  'lucide-target': Target,
  'lucide-telescope': Telescope,
  'lucide-tent': Tent,
  'lucide-tent-tree': TentTree,
  'lucide-terminal': Terminal,
  'lucide-test-tube': TestTube,
  'lucide-test-tube-diagonal': TestTubeDiagonal,
  'lucide-test-tubes': TestTubes,
  'lucide-text-align-center': TextAlignCenter,
  'lucide-text-align-end': TextAlignEnd,
  'lucide-text-align-justify': TextAlignJustify,
  'lucide-text-align-start': TextAlignStart,
  'lucide-text-cursor': TextCursor,
  'lucide-text-cursor-input': TextCursorInput,
  'lucide-text-initial': TextInitial,
  'lucide-text-quote': TextQuote,
  'lucide-text-search': TextSearch,
  'lucide-text-wrap': TextWrap,
  'lucide-theater': Theater,
  'lucide-thermometer': Thermometer,
  'lucide-thermometer-snowflake': ThermometerSnowflake,
  'lucide-thermometer-sun': ThermometerSun,
  'lucide-thumbs-down': ThumbsDown,
  'lucide-thumbs-up': ThumbsUp,
  'lucide-ticket': Ticket,
  'lucide-ticket-check': TicketCheck,
  'lucide-ticket-minus': TicketMinus,
  'lucide-ticket-percent': TicketPercent,
  'lucide-ticket-plus': TicketPlus,
  'lucide-ticket-slash': TicketSlash,
  'lucide-ticket-x': TicketX,
  'lucide-tickets': Tickets,
  'lucide-tickets-plane': TicketsPlane,
  'lucide-timeline': Timeline,
  'lucide-timer': Timer,
  'lucide-timer-off': TimerOff,
  'lucide-timer-reset': TimerReset,
  'lucide-toggle-left': ToggleLeft,
  'lucide-toggle-right': ToggleRight,
  'lucide-toilet': Toilet,
  'lucide-tool-case': ToolCase,
  'lucide-toolbox': Toolbox,
  'lucide-tornado': Tornado,
  'lucide-torus': Torus,
  'lucide-touchpad': Touchpad,
  'lucide-touchpad-off': TouchpadOff,
  'lucide-towel-rack': TowelRack,
  'lucide-tower-control': TowerControl,
  'lucide-toy-brick': ToyBrick,
  'lucide-tractor': Tractor,
  'lucide-traffic-cone': TrafficCone,
  'lucide-train-front': TrainFront,
  'lucide-train-front-tunnel': TrainFrontTunnel,
  'lucide-train-track': TrainTrack,
  'lucide-tram-front': TramFront,
  'lucide-transgender': Transgender,
  'lucide-trash': Trash,
  'lucide-trash2': Trash2,
  'lucide-tree-deciduous': TreeDeciduous,
  'lucide-tree-palm': TreePalm,
  'lucide-tree-pine': TreePine,
  'lucide-trees': Trees,
  'lucide-trending-down': TrendingDown,
  'lucide-trending-up': TrendingUp,
  'lucide-trending-up-down': TrendingUpDown,
  'lucide-triangle': Triangle,
  'lucide-triangle-alert': TriangleAlert,
  'lucide-triangle-dashed': TriangleDashed,
  'lucide-triangle-right': TriangleRight,
  'lucide-trophy': Trophy,
  'lucide-truck': Truck,
  'lucide-truck-electric': TruckElectric,
  'lucide-turkish-lira': TurkishLira,
  'lucide-turntable': Turntable,
  'lucide-turtle': Turtle,
  'lucide-tv': Tv,
  'lucide-tv-minimal': TvMinimal,
  'lucide-tv-minimal-play': TvMinimalPlay,
  'lucide-type': Type,
  'lucide-type-outline': TypeOutline,
  'lucide-umbrella': Umbrella,
  'lucide-umbrella-off': UmbrellaOff,
  'lucide-underline': Underline,
  'lucide-undo': Undo,
  'lucide-undo2': Undo2,
  'lucide-undo-dot': UndoDot,
  'lucide-unfold-horizontal': UnfoldHorizontal,
  'lucide-unfold-vertical': UnfoldVertical,
  'lucide-ungroup': Ungroup,
  'lucide-university': University,
  'lucide-unlink': Unlink,
  'lucide-unlink2': Unlink2,
  'lucide-unplug': Unplug,
  'lucide-upload': Upload,
  'lucide-usb': Usb,
  'lucide-user': User,
  'lucide-user-check': UserCheck,
  'lucide-user-cog': UserCog,
  'lucide-user-key': UserKey,
  'lucide-user-lock': UserLock,
  'lucide-user-minus': UserMinus,
  'lucide-user-pen': UserPen,
  'lucide-user-plus': UserPlus,
  'lucide-user-round': UserRound,
  'lucide-user-round-arrow-left': UserRoundArrowLeft,
  'lucide-user-round-check': UserRoundCheck,
  'lucide-user-round-cog': UserRoundCog,
  'lucide-user-round-key': UserRoundKey,
  'lucide-user-round-minus': UserRoundMinus,
  'lucide-user-round-pen': UserRoundPen,
  'lucide-user-round-plus': UserRoundPlus,
  'lucide-user-round-search': UserRoundSearch,
  'lucide-user-round-x': UserRoundX,
  'lucide-user-search': UserSearch,
  'lucide-user-star': UserStar,
  'lucide-user-x': UserX,
  'lucide-users': Users,
  'lucide-users-round': UsersRound,
  'lucide-utensils': Utensils,
  'lucide-utensils-crossed': UtensilsCrossed,
  'lucide-utility-pole': UtilityPole,
  'lucide-van': Van,
  'lucide-variable': Variable,
  'lucide-vault': Vault,
  'lucide-vector-square': VectorSquare,
  'lucide-vegan': Vegan,
  'lucide-venetian-mask': VenetianMask,
  'lucide-venus': Venus,
  'lucide-venus-and-mars': VenusAndMars,
  'lucide-vibrate': Vibrate,
  'lucide-vibrate-off': VibrateOff,
  'lucide-video': Video,
  'lucide-video-off': VideoOff,
  'lucide-videotape': Videotape,
  'lucide-view': View,
  'lucide-voicemail': Voicemail,
  'lucide-volleyball': Volleyball,
  'lucide-volume': Volume,
  'lucide-volume1': Volume1,
  'lucide-volume2': Volume2,
  'lucide-volume-off': VolumeOff,
  'lucide-volume-x': VolumeX,
  'lucide-vote': Vote,
  'lucide-wallet': Wallet,
  'lucide-wallet-cards': WalletCards,
  'lucide-wallet-minimal': WalletMinimal,
  'lucide-wallpaper': Wallpaper,
  'lucide-wand': Wand,
  'lucide-wand-sparkles': WandSparkles,
  'lucide-warehouse': Warehouse,
  'lucide-washing-machine': WashingMachine,
  'lucide-watch': Watch,
  'lucide-waves-arrow-down': WavesArrowDown,
  'lucide-waves-arrow-up': WavesArrowUp,
  'lucide-waves-horizontal': WavesHorizontal,
  'lucide-waves-ladder': WavesLadder,
  'lucide-waves-vertical': WavesVertical,
  'lucide-waypoints': Waypoints,
  'lucide-webcam': Webcam,
  'lucide-webcam-off': WebcamOff,
  'lucide-webhook': Webhook,
  'lucide-webhook-off': WebhookOff,
  'lucide-weight': Weight,
  'lucide-weight-tilde': WeightTilde,
  'lucide-wheat': Wheat,
  'lucide-wheat-off': WheatOff,
  'lucide-whole-word': WholeWord,
  'lucide-wifi': Wifi,
  'lucide-wifi-cog': WifiCog,
  'lucide-wifi-high': WifiHigh,
  'lucide-wifi-low': WifiLow,
  'lucide-wifi-off': WifiOff,
  'lucide-wifi-pen': WifiPen,
  'lucide-wifi-sync': WifiSync,
  'lucide-wifi-zero': WifiZero,
  'lucide-wind': Wind,
  'lucide-wind-arrow-down': WindArrowDown,
  'lucide-wine': Wine,
  'lucide-wine-off': WineOff,
  'lucide-workflow': Workflow,
  'lucide-worm': Worm,
  'lucide-wrench': Wrench,
  'lucide-wrench-off': WrenchOff,
  'lucide-x': X,
  'lucide-x-line-top': XLineTop,
  'lucide-zap': Zap,
  'lucide-zap-off': ZapOff,
  'lucide-zodiac-aquarius': ZodiacAquarius,
  'lucide-zodiac-aries': ZodiacAries,
  'lucide-zodiac-cancer': ZodiacCancer,
  'lucide-zodiac-capricorn': ZodiacCapricorn,
  'lucide-zodiac-gemini': ZodiacGemini,
  'lucide-zodiac-leo': ZodiacLeo,
  'lucide-zodiac-libra': ZodiacLibra,
  'lucide-zodiac-ophiuchus': ZodiacOphiuchus,
  'lucide-zodiac-pisces': ZodiacPisces,
  'lucide-zodiac-sagittarius': ZodiacSagittarius,
  'lucide-zodiac-scorpio': ZodiacScorpio,
  'lucide-zodiac-taurus': ZodiacTaurus,
  'lucide-zodiac-virgo': ZodiacVirgo,
  'lucide-zoom-in': ZoomIn,
  'lucide-zoom-out': ZoomOut,
}

export const availableLucideModuleIcons: Array<{ name: string; component: ModuleIconComponent }> =
  Object.entries(MODULE_LUCIDE_ICON_MAP)
    .map(([name, component]) => ({ name, component }))
    .sort((a, b) => a.name.localeCompare(b.name))

export const resolveModuleLucideIcon = (name?: string): ModuleIconComponent | undefined => {
  if (!name) return undefined
  const key = name.toLowerCase()
  if (!key.startsWith('lucide-')) return undefined
  return MODULE_LUCIDE_ICON_MAP[key]
}
